import React, { useState, Component, useEffect } from 'react';
import {
  Row,
  Col,
  Button,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Label,
  TabPane,
  TabContent,
  Nav,
  NavItem,
  NavLink,
  Table,
  Tooltip
} from 'reactstrap';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import AsyncSelect from 'react-select/async';

import useForm from 'lib/useForm';
import settings from 'settings';
import rotas from 'services/rotas';
import ReactSelect from '../../../components/Form/Select/Select';
import Loading from 'lib/loading';
import rest from 'lib/rest';
import { toDecimal } from '../../../lib/funcoesNumericas';
import Swal from 'sweetalert2';
import './style.css';
import NumberFormat from 'react-number-format';
import FormFeedback from 'reactstrap/lib/FormFeedback';
import FormText from 'reactstrap/lib/FormText';
import DateTime from 'react-datetime';
import moment from 'moment';
import paginationFactory from 'react-bootstrap-table2-paginator';

const FromCadastroProduto = ({ closeModal, produto_id, dadosNfe, filial_id }) => {

  const [activeTab, setActiveTab] = useState('1');

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
    if (((tab === '3') || (tab === '4') || (tab === '6')) && (form.produto_id === '')) {
      const propSweet = {
        show: true,
        title: 'Atenção',
        text: 'Produto ainda não cadastrado na central!',
        type: 'error'
      }
      //setSweetProps(propSweet);
      Swal.fire(propSweet.title,
        propSweet.text,
        propSweet.type
      )
      setActiveTab('1');
    }
  }

  //valores iniciais do formulario
  const inicialForm = {
    produto_id: '',
    cod_barras: '',
    produto: '',
    apresentacao: '',
    categoria_id: 0,
    categoria: '',
    subcategoria_id: 0,
    subcategoria: '',
    cod_tributacao: 0,
    tributacao: '',
    fornecedor_id: 0,
    fornecedor: '',
    unidade_id: 0,
    unidadeMedida: '',
    atualizar_preco: 'S',
    padrao_comissao_id: 0,
    padrao_comissao: '',
    grupo_compra_id: 0,
    grupo_compra: '',
    beneficio_id: 0,
    beneficio: '',
    prod_prcompra: '0',
    prod_prvenda: '0',
    prod_prpromocao: '0',
    prod_prcrediario: '0',
    prod_estminimo: '0',
    prod_ativo: 'S',
    hospitalar: 1,
    valor_ult_compra: '0',
    valor_inventario: '0',
    cmv_inventario: '0',
    desconto_maximo: '0',
    item_reajustado: 0,
    prod_cmv: '0',
    prod_prfarmapop: '0',
    prod_prfarmapop_bf: '0',
    autorizado_fpbf: 'N',
    quant_comp_ml: 0,
    cst_pis: '',
    cat_cofins: '',
    natureza_receita_pis_cofins: '',
    ncm: '',
    imposto_aliq: 0,
    cest: '',
    gerar_comissao_fp: 'S',
    controle_especial: 'N',
    controle_medicamento: 'N',
    controle: '',
    margem_lucro: 0,
    tipo_preco: 'M',
    lista: '',
    psicotropico: 'N',
    antimicrobiano: 'N',
    uso_continuo: 'N',
    tributacao_monofasica: 'N',
    iat: 'A',
    ippt: 'T',
    prod_reserva: 0,
    promocao_vista: 'N',
    promocao_convenio: 'N',
    registro_ms: '',
    listaPsicotropico: {
      id: '',
      title: ""
    }
  }

  const initialDetalhes = {
    inicio_promocao: "",
    prod_prcrediario: "",
    prod_prpromocao: "",
    prod_prvenda: "",
    promocao_convenio: "",
    promocao_leve: "",
    promocao_pague: "",
    promocao_permanente: "",
    promocao_vista: "",
    termino_promocao: "",
    tipo_preco_promocao_pl: ""
  }

  const initialSweet = {
    show: false,
    title: '',
    text: '',
    type: 'success'
  }

  const colunas = [
    {
      dataField: 'data_recebimento',
      text: 'Data da Compra',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'nota_fiscal',
      text: 'Nota Fiscal',
      align: 'left',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'fornecedor',
      text: 'Fornecedor',
      align: 'left',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'item_notas_quant',
      text: 'QTD',
      align: 'left',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'item_notas_prcompra',
      text: 'Pr. Compra',
      align: 'left',
      headerStyle: { cursor: 'default' },
      formatter: (cell, row) => {
        return ('R$ ' + row.item_notas_prcompra)
      }
    },
    {
      dataField: 'item_notas_desconto',
      text: 'Desconto',
      align: 'left',
      headerStyle: { cursor: 'default' },
      formatter: (cell, row) => {
        return (row.item_notas_desconto + ' %')
      }
    },
    {
      dataField: 'total_item',
      text: 'Preco Líquido',
      align: 'left',
      headerStyle: { cursor: 'default' },
      formatter: (cell, row) => {
        return ('R$ ' + row.total_item)
      }
    },
    {
      dataField: 'total_custo',
      text: 'Custo Final',
      align: 'left',
      headerStyle: { cursor: 'default' },
      formatter: (cell, row) => {
        return ('R$ ' + row.total_custo)
      }
    }
  ];

  const disabledCF = {
    inicio_promocao: true,
    prod_prcrediario: true,
    prod_prpromocao: true,
    prod_prvenda: true,
    promocao_convenio: true,
    promocao_leve: true,
    promocao_pague: true,
    promocao_permanente: true,
    promocao_vista: true,
    termino_promocao: true,
    tipo_preco_promocao_pl: true,
    desconto_escalonado: {
      quantidade: true,
      valor_pacote: true
    }

  }

  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm(inicialForm);
  
  // const [formRefProd, setFormRefProd] = useState(inicialForm);
  const [checkControleEspecial, setCheckControleEspecial] = useState(true);
  const [configFieldDetPromo, setConfigFieldDetPromo] = useState(disabledCF);
  const [dadosLojas, setDadosLojas] = useState([]);
  const [descontoEscalonado, setDescontoEscalonado] = useState({})
  const [disabledBtnGravar, setDisabledBtnGravar] = useState(false);
  const [disabledMarkup, setDisabledMarkup] = useState(true);
  const [disabledLista, setDisabledLista] = useState(true);
  const [loading, setLoading] = useState(true);
  const [loadingLojas, setLoadingLojas] = useState(true);
  const [loadingSubstancia, setLoadingSubstancia] = useState(false);
  const [listaEscalonado, setListaEscalonado] = useState([]);
  const [listaFornecedor, setListaFornecedor] = useState([]);
  const [listaCategoria, setListaCategoria] = useState([]);
  const [listaSubcategoria, setListaSubcategoria] = useState([]);
  const [listaUnidade, setListaUnidade] = useState([]);
  const [listaComissao, setListaComissao] = useState([]);
  const [listaTributacao, setListaTributacao] = useState([]);
  const [listaClassifTipo, setListaClassifTipo] = useState([]);
  const [novaSubstancia, setNovaSubstancia] = useState(0);
  const [novoProdutoRelacionado, setNovoProdutoRelacionado] = useState(0);
  const [listaSubstancia, setListaSubstancia] = useState([]);
  const [listaSubstanciaProduto, setListaSubstanciaProduto] = useState([]);
  const [listaPadraoComissao, setListaPadraoComissao] = useState([]);
  const [listaGrupoCompras, setListaGrupoCompras] = useState([]);
  const [listaBeneficios, setListaBeneficios] = useState([]);
  const [listaLojas, setListaLojas] = useState([]);
  const [listaLojasDetPromo, setListaLojasDetPromo] = useState([]);
  const [loja_id, setLojaId] = useState(0);
  const [loja_idDetPromo, setLojaIdDetPromo] = useState(0);
  const [lotes, setLotes] = useState([]);
  const [produtosRelacionados, setProdutosRelacionados] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [ultCompras, setUltCompras] = useState([]);
  const [visiblePrVenda, setVisiblePrVenda] = useState('visible');
  const [sweetProps, setSweetProps] = useState(initialSweet);
  //const [listaProdutos, setListaProdutos] = useState([]);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [detProdExibicao, setDetProdExibicao] = useState(initialDetalhes);
  const [detProdExibicaoRef, setDetProdExibicaoRef] = useState(initialDetalhes);
  const [loadingMkp, setLoadingMkp] = useState(false);
  const [loadingLista, setLoadingLista] = useState(false);
  const [loadingBusca, setLoadingBusca] = useState(false);
  const [oldEmbHosp, setOldEmbHosp] = useState(0);

  const [disabledUltCompra, setDisabledUltCompra] = useState(true);


  useEffect(()=>{
    clickPsiAnt({target:{value:form.controle}});   
  },[form.controle])

  const toggle = () => setTooltipOpen(!tooltipOpen);

  const listaPsicotropico = [
    { id: 'A1', title: 'A1' },
    { id: 'A2', title: 'A2' },
    { id: 'A3', title: 'A3' },
    { id: 'B1', title: 'B1' },
    { id: 'B2', title: 'B2' },
    { id: 'C1', title: 'C1' },
    { id: 'C2', title: 'C2' },
    { id: 'C3', title: 'C3' },
    { id: 'C4', title: 'C4' },
    { id: 'C5', title: 'C5' },
    { id: 'D1', title: 'D1' },
    { id: 'D2', title: 'D2' },
    { id: 'F1', title: 'F1' },
    { id: 'F2', title: 'F2' },
    { id: 'F3', title: 'F3' },
    { id: 'F4', title: 'F4' }
  ];

  const remDup = e => [...new Set(e)].sort().join("");

  const validaProduto = () => {

    if (form.cod_barras.length === 0) {
      Swal.fire('Atenção',
        'Por favor informe um código de barras!',
        'warning'
      )
      return (false);
    }

    if (form.fornecedor_id === 0) {
      Swal.fire('Atenção',
        'Por favor selecione um fornecedor!',
        'warning'
      )
      return (false);
    }

    if (form.categoria_id === 0) {
      Swal.fire('Atenção',
        'Por favor selecione uma categoria!',
        'warning'
      )
      return (false);
    }

    if (form.prod_unidade === '') {

      if (form.unidadeMedida) {
        form.prod_unidade = form.unidadeMedida.title;
      } else {
        Swal.fire('Atenção',
          'Por favor selecione uma unidade de medida!',
          'warning'
        )
        return (false);
      }
    }

    if (form.padrao_comissao_id === 0) {
      Swal.fire('Atenção',
        'Por favor selecione um padrão de comissão!',
        'warning'
      )
      return (false);
    }

    if (form.cod_tributacao === 0) {
      Swal.fire('Atenção',
        'Por favor selecione uma tributação!',
        'warning'
      )
      return (false);
    }

    if (form.prod_prvenda == 0) {
      Swal.fire('Atenção',
        'Por favor informe um preço de venda!',
        'warning'
      )
      return (false);
    }

    if (form.prod_prcompra == 0) {
      Swal.fire('Atenção',
        'Por favor informe um preço de compra!',
        'warning'
      )
      return (false);
    }

    // if (form.ncm.length < 8) {
    //   Swal.fire('Atenção',
    //     'Por favor informe um NCM!',
    //     'warning'
    //   )
    //   toggleTab('2');
      
    //   return (false);
    // }

    if (detProdExibicao.inicio_promocao !== ''){
      if ((!moment(detProdExibicao.inicio_promocao).isValid()) && (detProdExibicao.inicio_promocao.length < 10)) {
        Swal.fire('Atenção',
          'Digite uma data válida para inicio de promoção!',
          'warning'
        )
        return(false)
      }
    }

    if ((detProdExibicao.termino_promocao !== '') && (detProdExibicao.termino_promocao.length < 10)){
      if (!moment(detProdExibicao.termino_promocao).isValid()) {
        Swal.fire('Atenção',
          'Digite uma data válida para término de promoção!',
          'warning'
        )
        return(false);
      }
    }

    if((detProdExibicao.inicio_promocao === '') && (detProdExibicao.termino_promocao !== '')){
      Swal.fire('Atenção',
          'Preencha a data de inicio da promoção',
          'warning'
        )
        return(false);  
    }

    if((detProdExibicao.inicio_promocao !== '') && (detProdExibicao.termino_promocao === '')){
      Swal.fire('Atenção',
          'Preencha a data de término da promoção',
          'warning'
        )
        return(false);  
    }

    if((detProdExibicao.inicio_promocao !== '') && (detProdExibicao.termino_promocao !== '')){
      if(detProdExibicao.inicio_promocao !== detProdExibicao.termino_promocao ){
        if(moment(detProdExibicao.inicio_promocao,'DD/MM/YYYY').isAfter(moment(detProdExibicao.termino_promocao,'DD/MM/YYYY'))){
          Swal.fire('Atenção',
            'Período de promoção inválido',
            'warning'
          )
          return(false);  
        }
      }
    }

    //VALIDA CONTROLE ESPECIAL
    if (form.controle_medicamento === 'S') {

      // if ((form.psicotropico === 'N') && (form.antimicrobiano === 'N')) {
      //   Swal.fire('Atenção',
      //     'Por favor informe se o produto é psicotrópico ou antimicrobiano!',
      //     'warning'
      //   )
      //   return (false);
      // }

      if (form.psicotropico === 'S') {
        if (form.listaPsicotropico) {
          if (form.listaPsicotropico.title === '') {
            Swal.fire('Atenção',
              'Por favor informe uma lista para o psicotrópico!',
              'warning'
            )
            return (false);
          }
        } else {
          Swal.fire('Atenção',
            'Por favor informe uma lista para o psicotrópico!',
            'warning'
          )
          return (false);
        }


      }

      if ((form.registro_ms === '') && ((form.psicotropico === 'S') || (form.antimicrobiano === 'S'))) {
        Swal.fire('Atenção',
          'Por favor informe o registro MS!',
          'warning'
        )
        return (false);
      }

      if ((form.sngpc_unidade === '') && ((form.psicotropico === 'S') || (form.antimicrobiano === 'S'))) {
        Swal.fire('Atenção',
          'Por favor informe a unidade de medida do psicotrópico / antimicrobiano!',
          'warning'
        )
        return (false);
      }

      if ((form.registro_ms !== 'ISENTO') && (form.registro_ms.replace(/[^0-9|]/g, '') !== '')) {
        if (form.registro_ms.replace(/[^0-9|]/g, '').length < 13) {
          Swal.fire('Atenção',
            'Registro MS inválido',
            'warning'
          )
          return (false);
        }
      }
    }

    // let trib = form.tributacao.replace(/[^S|^T]/g, '');

    // trib = remDup(trib);

    // console.log(trib);
    // return(false)

    // if (validaCest() === false) {
    //   Swal.fire('Atenção',
    //     'Por favor informe um CEST!',
    //     'warning'
    //   )
    //   toggleTab('2')
    //   return (false);
    // }

    // if ((remDup(form.tributacao.replace(/[^S|^T]/g, '')) === 'ST')&&(form.cest.length < 7)) {
    //   Swal.fire('Atenção',
    //     'Por favor informe um CEST!',
    //     'warning'
    //   )
    //   return (false);
    // }

  }

  const validaNumero = (e) => {
    //console.log(e.target.name)
    const value = e.target.value

    if (e.target.name == 'imposto_aliq') {
      e.target.value = value.replace(/[^0-9|.|,]/g, '')
      form[e.target.name] = (value.replace(/[^0-9|.|,]/g, '')).toLocaleString('pt-br', { style: 'percent', currency: 'BRL' })
    } else {
      e.target.value = value.replace(/[^0-9]/g, '')
      form[e.target.name] = value.replace(/[^0-9]/g, '')
    }
  }

  const listarProdutos = () => {
    const parametros = {
      todos: 'N',
      produto_id: produto_id,
      filial_id: filial_id
    }
    const url = settings.url + rotas.produtos
    let retorno = rest.post(url, parametros);
    retorno.then(ret => {
      // console.log(ret);
      if (ret.erro === 'nao') {

        // if (ret.produtos[0].imposto_aliq == '') {
        //   ret.produtos[0].imposto_aliq = parseFloat(0)
        // } else {
        //   ret.produtos[0].imposto_aliq = parseFloat(ret.produtos.imposto_aliq)
        // }

        if (ret.produtos[0].psicotropico === 'S') {
          ret.produtos[0].controle = 'C';
          ret.produtos[0].controle_especial = 'S';
          ret.produtos[0].listaPsicotropico = {
            id: ret.produtos[0].lista,
            title: ret.produtos[0].lista
          }

          setCheckControleEspecial(false);
          setDisabledLista(false)
        }

        if (ret.produtos[0].antimicrobiano === 'S') {
          ret.produtos[0].controle = 'A';
          ret.produtos[0].controle_especial = 'S';
          setCheckControleEspecial(false);
        }

        if (ret.produtos[0].tipo_preco === 'L') {
          setDisabledMarkup(false)
        }

        if(ret.disabledUltCompra){
          setDisabledUltCompra(false)
        }        

        setForm(ret.produtos[0]);
        // setFormRefProd(ret.produtos[0]);

        setLoading(false);
      }
    })
  }

  const pesquisaProdutoRelacionado = (produto) => {

    if (produto.length >= 3) {
      const pesquisa = produto;
      const parametros = {
        todos: 'N',
        filial_id: filial_id,
        produto: pesquisa
      }

      const url = settings.url + rotas.produtos;
      const retorno = rest.post(url, parametros);
      let oProdutos = [];
      return retorno.then(ret => {
        ret.produtos.map(produto =>
          oProdutos.push({ value: produto.produto_id, label: produto.produto + ' - ' + produto.apresentacao })
        )
        return (oProdutos);
      })
    }
  }

  const listarFornecedores = () => {
    const url = settings.url + rotas.fornecedorProduto;
    
    //const retorno = rest.get(url + '/' + loja_id);
    const retorno = rest.get(url);
    let oFornecedores = [];
    retorno.then(ret => {
      if (ret.success === 'S') {
        ret.lista.map(fornecedor => {
          oFornecedores.push({ id: fornecedor.fornecedor_id, title: fornecedor.fornecedor })
        });
        setListaFornecedor(oFornecedores);
      }
    })
  }

  const listarCategorias = () => {
    const url = settings.url + rotas.categoriaProduto;
    const retorno = rest.get(url);
    let oCategoria = [];
    retorno.then(ret => {
      if (ret.success === 'S') {
        ret.lista.map(categoria => {
          oCategoria.push({ id: categoria.categoria_id, title: categoria.categoria })
        });
        setListaCategoria(oCategoria);
      }
    })
  }

  const listarSubcategorias = () => {
    const url = settings.url + rotas.subcategoriaProduto;
    const retorno = rest.get(url);
    let oSubcategoria = [];
    retorno.then(ret => {
      if (ret.success === 'S') {
        ret.lista.map(subcategoria => {
          oSubcategoria.push({ id: subcategoria.subcategoria_id, title: subcategoria.subcategoria })
        });
        setListaSubcategoria(oSubcategoria);
      }
    })
  }

  const listarPadraoComissao = () => {
    const url = settings.url + rotas.comissao;
    const retorno = rest.get(url);
    let oPadraoComissao = [];
    retorno.then(ret => {
      if (ret.success === 'S') {
        ret.lista.map(padrao_comissao => {
          oPadraoComissao.push({ id: padrao_comissao.padrao_comissao_id, title: padrao_comissao.padrao_comissao + '%' })
        });
        setListaPadraoComissao(oPadraoComissao);
      }
    })
  }

  const listarDetalhesPromocao = () => {

    if ((loja_idDetPromo > 0) && (produto_id > 0)) {
      const url = settings.url + rotas.listarDetalhesPromocao;

      // let retorno = {};
      // if(lj_id > 0){
      //   retorno = rest.get(url + '?produto_id=' + produto_id + '&filial_id=' + lj_id);
      // }else{
      const retorno = rest.get(url + '?produto_id=' + produto_id + '&filial_id=' + loja_idDetPromo);
      // }

      retorno.then(ret => {
        if ((ret.erro === 'nao') && (ret.lista.length > 0)) {
          setDetProdExibicao(ret.lista[0]);

          //valida config_field
          if (ret.config_field.length > 0) {
            dadosLojas.map(loja => {
              if (loja.filial_id === loja_idDetPromo) {
                //se for a matriz libera todos os campo
                if (loja.is_central === 'S') {
                  let dcf = disabledCF;

                  dcf.inicio_promocao = false;
                  dcf.prod_prcrediario = true;
                  dcf.prod_prvenda = true;
                  dcf.prod_prpromocao = true;
                  dcf.promocao_convenio = false;
                  dcf.promocao_leve = false;
                  dcf.promocao_pague = false;
                  dcf.promocao_permanente = false;
                  dcf.promocao_vista = false;
                  dcf.termino_promocao = false;
                  dcf.tipo_preco_promocao_pl = false;

                  dcf.desconto_escalonado.quantidade = false;
                  dcf.desconto_escalonado.valor_pacote = false;


                  setConfigFieldDetPromo(dcf);
                } else {//se for filial e houver config field filtra de acordo com eles
                  let dcf = disabledCF;

                  dcf.inicio_promocao = true;
                  dcf.prod_prcrediario = true;
                  dcf.prod_prvenda = true;
                  dcf.prod_prpromocao = true;
                  dcf.promocao_convenio = true;
                  dcf.promocao_leve = true;
                  dcf.promocao_pague = true;
                  dcf.promocao_permanente = true;
                  dcf.promocao_vista = true;
                  dcf.termino_promocao = true;
                  dcf.tipo_preco_promocao_pl = true;

                  dcf.desconto_escalonado.quantidade = true;
                  dcf.desconto_escalonado.valor_pacote = true;

                  ret.config_field.map(ret => {                    
                    if (ret.filial_id === loja_idDetPromo) {
                      // console.log(ret.campo.toLowerCase())
                      if (ret.campo.toLowerCase() === 'inicio_promocao') {
                        // console.log('aqui')
                        if (ret.regra === 'N') {
                          dcf.inicio_promocao = false;
                        } else {
                          dcf.inicio_promocao = true;
                        }
                      }
                      else
                        if (ret.campo.toLowerCase() === 'prod_prcrediario') {
                          if (ret.regra === 'N') {
                            dcf.prod_prcrediario = false;
                          } else {
                            dcf.prod_prcrediario = true;
                          }
                        }
                        else
                          if (ret.campo.toLowerCase() === 'prod_prvenda') {

                            if (ret.regra === 'N') {
                              dcf.prod_prvenda = false;
                            } else {
                              dcf.prod_prvenda = true;
                            }
                          }
                          else
                            if (ret.campo.toLowerCase() === 'prod_prpromocao') {

                              if (ret.regra === 'N') {
                                dcf.prod_prpromocao = false;
                              } else {
                                dcf.prod_prpromocao = true;
                              }
                            }
                            else
                              if (ret.campo.toLowerCase() === 'promocao_convenio') {
                                if (ret.regra === 'N') {
                                  dcf.promocao_convenio = false;
                                } else {
                                  dcf.promocao_convenio = true;
                                }
                              }
                              else
                                if (ret.campo.toLowerCase() === 'promocao_leve') {
                                  if (ret.regra === 'N') {
                                    dcf.promocao_leve = false;
                                  } else {
                                    dcf.promocao_leve = true;
                                  }
                                }
                                else
                                  if (ret.campo.toLowerCase() === 'promocao_pague') {
                                    if (ret.regra === 'N') {
                                      dcf.promocao_pague = false;
                                    } else {
                                      dcf.promocao_pague = true;
                                    }
                                  }
                                  else
                                    if (ret.campo.toLowerCase() === 'promocao_permanente') {
                                      if (ret.regra === 'N') {
                                        dcf.promocao_permanente = false;
                                      } else {
                                        dcf.promocao_permanente = true;
                                      }
                                    }
                                    else
                                      if (ret.campo.toLowerCase() === 'promocao_vista') {
                                        if (ret.regra === 'N') {
                                          dcf.promocao_vista = false;
                                        } else {
                                          dcf.promocao_vista = true;
                                        }
                                      }
                                      else
                                        if (ret.campo.toLowerCase() === 'termino_promocao') {                                          
                                          if (ret.regra === 'N') {
                                            dcf.termino_promocao = false;
                                          } else {
                                            dcf.termino_promocao = true;
                                          }
                                        }
                                        else
                                          if (ret.campo.toLowerCase() === 'tipo_preco_promocao_pl') {
                                            if (ret.regra === 'N') {
                                              dcf.tipo_preco_promocao_pl = false;
                                            } else {
                                              dcf.tipo_preco_promocao_pl = true;
                                            }
                                          }
                    }
                  })

                  setConfigFieldDetPromo(disabledCF);
                }
              }
            })

          } else {

            dadosLojas.map(loja => {
              if (loja.filial_id === loja_idDetPromo) {
                if (loja.is_central === 'S') {
                  let dcf = disabledCF;

                  dcf.inicio_promocao = false;
                  dcf.prod_prcrediario = true;
                  dcf.prod_prvenda = true;
                  dcf.prod_prpromocao = true;
                  dcf.promocao_convenio = false;
                  dcf.promocao_leve = false;
                  dcf.promocao_pague = false;
                  dcf.promocao_permanente = false;
                  dcf.promocao_vista = false;
                  dcf.termino_promocao = false;
                  dcf.tipo_preco_promocao_pl = false;

                  dcf.desconto_escalonado.quantidade = false;
                  dcf.desconto_escalonado.valor_pacote = false;

                  setConfigFieldDetPromo(dcf);
                } else {
                  let dcf = disabledCF;

                  dcf.inicio_promocao = true;
                  dcf.prod_prcrediario = true;
                  dcf.prod_prvenda = true;
                  dcf.prod_prpromocao = true;
                  dcf.promocao_convenio = true;
                  dcf.promocao_leve = true;
                  dcf.promocao_pague = true;
                  dcf.promocao_permanente = true;
                  dcf.promocao_vista = true;
                  dcf.termino_promocao = true;
                  dcf.tipo_preco_promocao_pl = true;

                  dcf.desconto_escalonado.quantidade = true;
                  dcf.desconto_escalonado.valor_pacote = true;

                  setConfigFieldDetPromo(dcf);
                }
              }
            })
          }
        } else {
          Swal.fire(
            'Atenção',
            'Produto não localizado nesta loja!',
            'error'
          )
          setDetProdExibicao(initialDetalhes);
          setConfigFieldDetPromo(disabledCF)
        }
      })
    }
  }


  const listarTributacao = () => {
    const url = settings.url + rotas.tributacao;
    const retorno = rest.get(url);
    let oCodTributacao = [];
    retorno.then(ret => {
      if (ret.success === 'S') {
        ret.tributacoes.map(tributacao => {
          oCodTributacao.push({ id: tributacao.tributacao_id, title: tributacao.tributacao })
        });
        setListaTributacao(oCodTributacao);
      }
    })
  }

  const listarGrupoCompras = () => {
    const url = settings.url + rotas.grupoComprasProduto;
    const retorno = rest.get(url);
    let oGrupoCompras = [];
    retorno.then(ret => {
      if (ret != '' && ret.success && ret.success == 'S' && ret.grupo != '') {
        ret.lista.map(grupo => {
          oGrupoCompras.push({ id: grupo.grupo_id, title: grupo.grupo })
        });
        setListaGrupoCompras(oGrupoCompras);
      }
    })
  }

  const listarBeneficios = () => {
    const url = settings.url + rotas.beneficioProduto;
    const retorno = rest.get(url);
    let oBeneficios = [];
    retorno.then(ret => {
      
      if (ret != '' && ret.success && ret.success == 'S' && ret.lista != null) {
        ret.lista.map(beneficio => {
          oBeneficios.push({ id: beneficio.beneficio_id, title: beneficio.beneficio })
        });
        setListaBeneficios(oBeneficios);
      }
    })
  }

  const listarUnidadeMedida = () => {
    const url = settings.url + rotas.listarUnidadeMedida;
    const retorno = rest.get(url);
    let oUnidadeMedida = [];
    retorno.then(ret => {
      if (ret != '' && ret.success && ret.success == 'S' && ret.unidadeMedida != '') {
        ret.unidadeMedida.map((unidade, idx) => {
          //console.log(unidade);
          oUnidadeMedida.push({ id: unidade.prod_unidade, title: unidade.prod_unidade })
        });
        setListaUnidade(oUnidadeMedida);
        //console.log(oUnidadeMedida);
      }
    })
  }

  const listarClassifTipo = () => {
    const url = settings.url + rotas.classifTipo;
    //console.log(url);
    const retorno = rest.get(url);
    let oClassifTipo = [];
    //console.log(retorno);
    retorno.then(ret => {
      if (ret != '' && ret.success && ret.success == 'S' && ret.lista != '') {
        ret.lista.map(classe => {
          oClassifTipo.push({ id: classe.classe_id, title: classe.classe })
        });
        setListaClassifTipo(oClassifTipo);
      }
    })
  }

  const listarsubstanciasProduto = () => {
    const url = settings.url + rotas.listarSubstanciasProduto;
    const retorno = rest.get(url + '?id=' + produto_id);
    let oSubstancias = [];
    retorno.then(ret => {
      if (ret.success === 'S') {
        ret.substancias.map(substancia => {
          oSubstancias.push({ id: substancia.substancia_id, title: substancia.substancia })
        });
        setListaSubstanciaProduto(oSubstancias);
      }
    })
  }

  const listarProdutosRelacionados = () => {

    const url = settings.url + rotas.listarProdutosRelacionados;
    const retorno = rest.get(url + '?id=' + produto_id);
    retorno.then(ret => {

      if (ret.success === 'S') {
        //console.log(ret.produtos);
        setProdutosRelacionados(ret.produtos);
      }
    })
  }

  const listarsubstancias = () => {
    const url = settings.url + rotas.substancia;
    const retorno = rest.get(url);
    let oSubstancias = [];
    retorno.then(ret => {
      if (ret.success === 'S') {
        ret.lista.map(substancia => {
          oSubstancias.push({ id: substancia.substancia_id, title: substancia.substancia })
        });
        setListaSubstancia(oSubstancias);
      }
    })
  }

  const listarUltCompras = (loja_id) => {
    setUltCompras([]);

    const url = settings.url + rotas.ultCompras;

    const parametros = {
      loja_id: loja_id,
      produto_id: produto_id
    }

    const retorno = rest.post(url, parametros);
    retorno.then(ret => {
      if (ret.success === 'S') {
        //console.log(loja_id);
        setUltCompras(ret.retorno);
      }
    })
  }

  const listarLojas = () => {
    /*const lojas = [{
      id: 1,
      title: 'LOJA 1'
    },
    {
      id: 2,
      title: 'LOJA 2'
    }
    ];
    setListaLojas(lojas);*/

    const url = settings.url + rotas.lojas;
    const retorno = rest.get(url);
    let oLojas = [];
    let nLoja = '';

    retorno.then(ret => {
      if (ret.success === 'S') {
        ret.lista.map(loja => {
          oLojas.push({ id: loja.filial_id, title: loja.fantasia });
          if (loja.filial_id === filial_id) {
            nLoja = loja.fantasia;
          }
        });
        setDadosLojas(ret.lista);
        setListaLojas(oLojas);
        setLojaId(oLojas[0].id)//SETA A MATRIZ COMO LOJA DEFAULT
        setListaLojasDetPromo(oLojas);
        setLojaIdDetPromo(oLojas[0].id);
        setLoadingLojas(false);
      }
    })
  }

  const listarLotes = (row) => {
    //console.log(loja_id);
    const url = settings.url + rotas.listarLotesProdutos;

    const nota_fiscal = row.nota_fiscal;
    //const filial_id = loja_id;

    const retorno = rest.get(url + '?nota_fiscal=' + nota_fiscal + '&filial_id=' + loja_id + '&produto_id=' + produto_id);

    retorno.then(ret => {
      if (ret.success === 'S') {
        //console.log(ret);
        setLotes(ret.retorno);
      }
    })
  }

  const selecionaProdutoRelacionado = (evt) => {
    setNovoProdutoRelacionado(evt.value);
  }

  const gravarProdutoRelacionado = () => {
    //console.log(row.nota_fiscal);

    const url = settings.url + rotas.gravaProdutoRelacionado;

    const parametros = {
      produto_id: produto_id,
      filial_id: filial_id,
      produto_relacionado: novoProdutoRelacionado
    }

    const retorno = rest.post(url, parametros);
    retorno.then(ret => {
      // console.log(ret);
      if (ret.success === 'S') {
        let title = '';
        let type = 'success';

        if (ret.success === 'S') {
          title = 'Sucesso';
          type = 'success';
        } else {
          title = 'Erro';
          type = 'danger';
        }
        const propSweet = {
          show: true,
          title: title,
          text: ret.msg,
          type: type
        }
        //console.log(propSweet);
        Swal.fire(propSweet.title,
          propSweet.text,
          propSweet.type
        )
        listarProdutosRelacionados();
      }
    })
  }

  // const setSweet = () => {
  //   setSweetProps(initialSweet);
  // }

  const onChangeSubstancia = (evt) => {
    setNovaSubstancia(evt.id);
  }

  const onChangeLojas = (evt) => {
    setLojaId(evt.id);
    //setNomeLoja(evt.title);
    listarUltCompras(evt.id);
  }

  const onChangeLojasDetPromo = (evt) => {
    setLojaIdDetPromo(evt.id);
  }

  const onChangeDateDet = campo => {
    return (evt) => {
      if (evt.length != undefined) {
        if(evt.length === 0){
          setDetProdExibicao({
            ...detProdExibicao,
            [campo]: evt
          })
        }else if (evt.length === 2) {
          setDetProdExibicao({
            ...detProdExibicao,
            [campo]: evt + '/'
          })
        } else if (evt.length === 5) {
          setDetProdExibicao({
            ...detProdExibicao,
            [campo]: evt + '/'
          })
        } else if (evt.length >= 6 && evt.length <= 10) {
          setDetProdExibicao({
            ...detProdExibicao,
            [campo]: evt
          })
        } else if (evt.length === 10) {
          setDetProdExibicao({
            ...detProdExibicao,
            [campo]: detProdExibicao[campo]
          })
        } else if (evt.length > 10) {
          Swal.fire(
            'Atenção',
            'Data Inválida',
            'error'
          ).then(r => {
            evt = evt.substring(0, 10);
            setDetProdExibicao({
              ...detProdExibicao,
              [campo]: detProdExibicao[campo]
            })
          })
        }
      } else {
        setDetProdExibicao({
          ...detProdExibicao,
          [campo]: evt.format('DD/MM/YYYY')
        })
      }
    }
  }

  const onChangeDetPromo = (campo) => {

    return (evt) => {

      if (evt.target) {
        evt.target.value = evt.target.value.replace(',', '.');
        evt.target.value = evt.target.value.replace('R$ ', '');
        evt.target.value = evt.target.value.replace('%', '');

        if (evt.target.type === 'checkbox') {
          if (evt.target.checked === true) {
            evt.target.value = 'S'
          } else if (evt.target.checked === false) {
            evt.target.value = 'N'
          }
        }

        if (evt.target.type === 'radio') {
          if (evt.target.checked) {
            evt.target.value = evt.target.id
          }
        }
      }
      setDetProdExibicao({
        ...detProdExibicao,
        [campo]: evt.target.value
      })
    }
  }

  const onChangeEscalonado = (campo) => {

    return (evt) => {

      if (evt.target) {
        evt.target.value = evt.target.value.replace(',', '.');
        evt.target.value = evt.target.value.replace('R$ ', '');
        evt.target.value = evt.target.value.replace('%', '');

        if (evt.target.type === 'checkbox') {
          if (evt.target.checked === true) {
            evt.target.value = 'S'
          } else if (evt.target.checked === false) {
            evt.target.value = 'N'
          }
        }

        if (evt.target.type === 'radio') {
          if (evt.target.checked) {
            evt.target.value = evt.target.id
          }
        }
      }
      setDescontoEscalonado({
        ...descontoEscalonado,
        [campo]: evt.target.value
      })
    }
  }

  const removeSubstancia = (substancia_id) => {

    Swal.fire({
      title: 'Confirmação',
      text: 'Confirma exclusão da substância?',
      icon: 'question',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      cancelButtonColor: '#d33'
    }).then((result) => {
      //console.log(result);
      if (result.isConfirmed) {
        const url = settings.url + rotas.removeSubstanciaProduto;

        const parametros = {
          produto_id: produto_id,
          filial_id: filial_id,
          substancia_id: substancia_id
        }

        const retorno = rest.post(url, parametros);
        retorno.then(ret => {
          if (ret.success === 'S') {
            if (ret.success === 'S') {
              let title = '';
              let type = 'success';

              if (ret.success === 'S') {
                title = 'Sucesso';
                type = 'success';
              } else {
                title = 'Erro';
                type = 'danger';
              }
              const propSweet = {
                show: true,
                title: title,
                text: ret.msg,
                type: type
              }
              listarsubstanciasProduto();
              //setLoadingSubstancia(false);
            }
          }
        })
      }
    })
  }

  const gravaNovaSubstancia = () => {
    const url = settings.url + rotas.gravaSubstanciaProduto;
    const parametros = {
      produto_id: produto_id,
      filial_id: filial_id,
      substancia_id: novaSubstancia
    }
    const retorno = rest.put(url, parametros);
    retorno.then(ret => {
      if (ret.success === 'S') {
        let title = '';
        let type = 'success';

        if (ret.success === 'S') {
          title = 'Sucesso';
          type = 'success';
        } else {
          title = 'Erro';
          type = 'danger';
        }
        const propSweet = {
          show: true,
          title: title,
          text: ret.msg,
          type: type
        }
        //setSweetProps(propSweet);
        Swal.fire(propSweet.title,
          propSweet.text,
          propSweet.type
        )
        listarsubstanciasProduto();
      }
    })
  }

  const removeProdutoRelacionado = (produto_id_relacionado) => {
    const url = settings.url + rotas.removeProdutoRelacionado;
    const parametros = {
      produto_id: produto_id,
      filial_id: filial_id,
      produto_id_relacionado: produto_id_relacionado
    }
    const retorno = rest.post(url, parametros);
    retorno.then(ret => {
      if (ret.success === 'S') {
        let title = '';
        let type = 'success';

        if (ret.success === 'S') {
          title = 'Sucesso';
          type = 'success';
        } else {
          title = 'Erro';
          type = 'danger';
        }
        const propSweet = {
          show: true,
          title: title,
          text: ret.msg,
          type: type
        }
        Swal.fire(propSweet.title,
          propSweet.text,
          propSweet.type
        )
        //setSweetProps(propSweet);
        listarProdutosRelacionados();
      }
    })
  }

  const validaCest = () => {
    if (form.tributacao.id) {
      if (remDup(form.tributacao.title) === 'ST') {
        if (form.cest.length < 7) {
          return (false)
        } else {
          return (true);
        }
      } else {
        return (null);
      }
    } else {
      if (remDup(form.tributacao) === 'ST') {
        if (form.cest.length < 7) {
          return (false)
        } else {
          return (true);
        }
      } else {
        return (null)
      }
    }
  }

  const tipoPreco = (evt) => {
    setLoadingMkp(true);
    if (evt.target.id === 'monitorado') {
      if (evt.target.checked) {
        const frm = form;
        frm.tipo_preco = 'M';
        frm.margem_lucro = '0';
        setDisabledMarkup(true);
        setDisabledBtnGravar(false)
        setForm(frm)
        setRefresh(refresh + 1)
      }

    } else if (evt.target.id === 'liberado') {
      if (evt.target.checked) {
        form.tipo_preco = 'L';
        setDisabledMarkup(false);
      }
    }


    //console.log(form)
  }

  const setLista = (valor) => {
    form.prod_lista = valor;
  }

  const setTributacaoMonofasica = (evt) => {
    if (evt.target.checked) {
      form.tributacao_monofasica = 'S'
    } else {
      form.tributacao_monofasica = 'N'
    }
  }

  useEffect(() => {
    if (form.fornecedor.id) {
      if (form.fornecedor_id !== form.fornecedor.id) {
        form.fornecedor_id = form.fornecedor.id;
      }
    }

    if (form.categoria.id) {
      if (form.categoria_id !== form.categoria.id) {
        form.categoria_id = form.categoria.id;
      }
    }

    if (form.subcategoria.id) {
      if (form.subcategoria_id !== form.subcategoria.id) {
        form.subcategoria_id = form.subcategoria.id;
      }
    }

    if (form.padrao_comissao.id) {
      if (form.padrao_comissao_id !== form.padrao_comissao.id) {
        form.padrao_comissao_id = form.padrao_comissao.id;
      }
    }

    if (form.tributacao.id) {
      if (form.cod_tributacao !== form.tributacao.id) {
        form.cod_tributacao = form.tributacao.id;
      }
    }

    if (form.grupo_compra) {
      if (form.grupo_compra_id !== form.grupo_compra.id) {
        form.grupo_compra_id = form.grupo_compra.id;
      }
    }

    if (form.controle === undefined) {
      form.controle = '';
    }

    // if (form.beneficio) {
    //   if (form.beneficio_id !== form.beneficio.id) {
    //     console.log('beneficio');
    //     form.beneficio_id = form.beneficio.id;
    //   }
    // }

    if (form.unidade_id === 0) {
      form.unidade_id = form.prod_unidade;
    }

    // if ((form.ncm !== '' && form.ncm.substring(0, 4) >= '3001') && (form.ncm.substring(0, 4) <= '3006')) {
    //   form.controle_medicamento = 'S'
    //   setTooltipOpen(false)
    // } else {
    //   form.controle_medicamento = 'N'
    //   setTooltipOpen(true)
    // }


    setLoadingLista(false);


    //console.log(form);
  }, [form]);

  useEffect(() => {
    if ((form.produto_id === 0) || (form.produto_id === '')) {
      if (form.cod_barras !== '') {
        verificaCodBarras(form.cod_barras);
      }
    }
  }, [form.cod_barras])

  useEffect(() => {
    if (produto_id > 0) {
      listarProdutos();

    } else if (dadosNfe) {
      //SE TIVER O OBJETO dadosNfe E PORQUE FOI ACIONADA PELO LANCAMENTO DE NFE PARA CADASTRAR UM NOVO PRODUTO
      //console.log(dadosNfe);
      inicialForm.cod_barras = dadosNfe.cod_barras;
      inicialForm.produto = dadosNfe.produto;
      filial_id = dadosNfe.filial_id;
      setForm(inicialForm);
      setLoading(false);
    } else {
      setForm(inicialForm);
      setLoading(false);
    }
    listarLojas();
    listarFornecedores();
    listarCategorias();
    listarSubcategorias();
    listarPadraoComissao();
    listarTributacao();
    listarGrupoCompras();
    listarBeneficios();
    listarClassifTipo();
    listarsubstanciasProduto();
    listarsubstancias();
    listarProdutosRelacionados();
    listarUnidadeMedida();
    listarUltCompras(filial_id);
    listarDetalhesPromocao();
    listarEscalonado();
  }, [])

  useEffect(() => {
    if (listaFornecedor.length === 0) {
      listarFornecedores();
    }

    if (listaCategoria.length === 0) {
      listarCategorias();
    }
  }, [loja_id])

  useEffect(() => {
    listarDetalhesPromocao();
  }, [loja_idDetPromo])

  useEffect(() => {
    setLoadingMkp(false);
  }, [form.tipo_preco])

  const gravaProduto = () => {

    if (validaProduto() === false) {
      return
    }

    if (form.tributacao.id > 0) {
      form.tributacao_id = form.tributacao.id;
    }

    /*verifica os detalhes / promocao sao referentes a matriz ou a filial */
    let detalhesP = {};


    /*se for matriz, pega o preco de venda principal que esta na outra aba */
    dadosLojas.map(loja => {
      if (loja.filial_id === detProdExibicao.filial_id) {
        if (loja.is_central === 'S') {
          detProdExibicao.prod_prvenda = form.prod_prvenda;
          detProdExibicao.prod_prpromocao = form.prod_prpromocao;
          detProdExibicao.prod_prcrediario = form.prod_prcrediario;
        }
      }
    })

    detalhesP = detProdExibicao;

    /*se o preco de venda estiver vazio e porque nao foi localizado na tabela produtos_me
    entao nao manda nada no detalhes promocao */
    if (detProdExibicao.prod_prvenda === '') {
      detalhesP = {};
    }

    const url = settings.url + rotas.gravaProduto;
    const parametros = {
      produto: form,
      // produtoRef: formRefProd,
      detalhes: detalhesP,
      detalhesRef:detProdExibicaoRef
    }

    // console.log(parametros)
    // return;

    if (form.produto_id > 0) {
      const retorno = rest.post(url, parametros);
      retorno.then(ret => {
        // console.log(ret)
        let title = '';
        let type = 'success';

        if (ret.success === 'S') {
          title = 'Sucesso';
          type = 'success';
        } else {
          title = 'Erro';
          type = 'danger';
        }
        const propSweet = {
          show: true,
          title: title,
          text: ret.msg,
          type: type
        }
        //setSweetProps(propSweet);
        Swal.fire(propSweet.title,
          propSweet.text,
          propSweet.type
        )
      })
    } else {
      const retorno = rest.put(url, parametros);
      retorno.then(ret => {
        let title = '';
        let type = 'success';

        if (ret.success === 'S') {
          title = 'Sucesso';
          type = 'success';
        } else {
          title = 'Erro';
          type = 'danger';
        }
        const propSweet = {
          show: true,
          title: title,
          text: ret.msg,
          type: type
        }
        //setSweetProps(propSweet);
        Swal.fire(propSweet.title,
          propSweet.text,
          propSweet.type
        )

        if (type === 'success') {
          closeModal({ produto: { visible: false } })
        }

      })
    }
  }

  const alterouHospitalar = () => {
    if ((form.hospitalar > 1) && (form.prod_prvenda > 0) && (oldEmbHosp != form.hospitalar) && (oldEmbHosp > 0)) {
      Swal.fire({
        title: 'Confirmação',
        text: "Deseja dividir o preço de venda pela embalagem hospitalar?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim'
      }).then((result) => {
        if (result.isConfirmed) {
          let frm = form;
          frm.prod_prvenda = (frm.prod_prvenda / frm.hospitalar) + '';
          setForm(frm);
          setRefresh(refresh + 1)
        }
      })
    }
    setOldEmbHosp(0);
  }

  const calculaMargemApurada = () => {
    let total = 0;

    if (form.prod_prpromocao > 0) {
      if ((form.prod_prpromocao != 0) && (form.valor_ult_compra.replace('R$ ', '').replace(',', '.') != 0)) {
        total = Number(((form.prod_prpromocao - form.valor_ult_compra.replace('R$ ', '').replace(',', '.')) / form.valor_ult_compra.replace('R$ ', '').replace(',', '.')) * 100).toFixed(2);
      }
    } else {
      if ((form.prod_prvenda != 0) && (form.valor_ult_compra.replace('R$ ', '').replace(',', '.') != 0)) {
        total = Number(((form.prod_prvenda - form.valor_ult_compra.replace('R$ ', '').replace(',', '.')) / form.valor_ult_compra.replace('R$ ', '').replace(',', '.')) * 100).toFixed(2);
      }
    }
    return total;
  }

  //console.log(form);

  const calculaMKP = (valor) => {

    let total = 0;

    if (form.valor_ult_compra.replace('R$ ', '').replace(',', '.') > 0) {
      //setVisiblePrVenda('invisible');
      setLoading(true);

      Swal.fire({
        title: 'Atenção',
        text: 'Gostaria de calcular o preço de venda?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        cancelButtonColor: '#d33'
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          form.prod_prvenda = parseFloat((Number(form.valor_ult_compra.replace('R$ ', '').replace(',', '.')) + ((form.valor_ult_compra.replace('R$ ', '').replace(',', '.') * form.margem_lucro.replace(',', '.')) / 100))).toFixed(2);
        } else if (result.isDenied) {

        }
        setDisabledBtnGravar(false);
        setLoading(false);
      })

    }
    setDisabledBtnGravar(false);
  }

  const focusMarkup = () => {
    setDisabledBtnGravar('invisible');
    //setDisabledBtnGravar(true);
  }

  const clickControle = (vlr) => {

    if (vlr.target.checked === false) {
      form.controle_especial = 'N';
      form.psicotropico = 'N';
      form.antimicrobiano = 'N';
      form.controle = 'N';
      form.listaPsicotropico = {
        id: '',
        title: ''
      }
      setCheckControleEspecial(true);
      setDisabledLista(true);
    } else {
      form.controle_especial = 'S';
      form.psicotropico = 'N';
      form.antimicrobiano = 'N';
      form.controle = 'N';
      form.listaPsicotropico = {
        id: '',
        title: ''
      }
      setCheckControleEspecial(false);
      setDisabledLista(false);
    }
  }

  const clickPsiAnt = (e) => {
    //console.log(e.target.value)
    // const frm = JSON.parse(JSON.stringify(form))
    let frm = {...form};

    if (frm.registro_ms === 'ISENTO') {
      frm.registro_ms = '';
    }

    if (e.target.value == "C") {
      if ((frm.psicotropico !== 'S') || (frm.antimicrobiano !== 'N')) {        
        // frm = {...form,
        //         psicotropico : "S",
        //         antimicrobiano : "N"
        //       }        
        frm.psicotropico = "S";
        frm.antimicrobiano = "N";
        setDisabledLista(false);
        setLoadingLista(true);
      }
    } else if (e.target.value == "A") {
      if ((frm.psicotropico !== 'N') || (frm.antimicrobiano !== 'S')) {        
        frm.psicotropico = "N";
        frm.antimicrobiano = "S";
        frm.listaPsicotropico = { id: '', title: '' }
        frm.lista = '';
        setDisabledLista(true);
        setLoadingLista(true);
      }
    } else {
      //const frm = form;
      if ((frm.psicotropico !== 'N') || (frm.antimicrobiano !== 'N')) {        
        frm.psicotropico = "N";
        frm.antimicrobiano = "N";
        frm.sngpc_unidade = '';
        frm.listaPsicotropico = { id: '', title: '' }
        frm.lista = '';
        setDisabledLista(true);
        setLoadingLista(true);
      }
    }    
    setForm(frm);
    setRefresh(refresh + 1);
  }

  const checaListaPsicotropico = () => {
    if (form.controle === 'C') {

      if (form.listaPsicotropico) {
        //console.log('sim')
        if (form.listaPsicotropico.title === '') {
          return (true)
        } else {
          return (false)
        }
      } else if (form.lista !== undefined) {
        if (form.lista === '') {
          return (true)
        } else {
          return (false)
        }
      } else {
        return (false)
      }
    } else {
      return (false)
    }

  }

  const clickUso = (e) => {
    var check = (e.target.checked)
    // console.log(check)
    if (!check) {
      form.duracao = ''

    }
  }

  const mapInfoProdMCX = (busca, rtrib) => {
    const campos = {};
    campos.produto      = busca.produto      ? busca.produto.substring(0, 50).toUpperCase() : '';
    campos.apresentacao = busca.apresentacao || busca.APRESENTACAO || '';
    campos.ncm          = busca.ncm || '';
    campos.registro_ms  = busca.registroms ? busca.registroms[0] : '';

    const cestRaiz = (busca.cest && busca.cest !== '0000000') ? busca.cest : '';
    campos.cest = cestRaiz;

    if (busca.mcx) {
      const mcx = busca.mcx;
      campos.cst_pis                     = mcx.CSTPIS_S    || '';
      campos.cst_cofins                  = mcx.CSTCOF_S    || '';
      campos.natureza_receita_pis_cofins = mcx.NATRECEITA  || '';
      campos.imposto_aliq                = mcx.Aliq_IPI    || 0;
      campos.aliq_icms_deson             = mcx.ALIQ_DESICMS || '';

      if (mcx.COD_CEST && mcx.COD_CEST !== '0000000') campos.cest = mcx.COD_CEST;

      const listaMap = { '1': '+', '-1': '-', '0': 'N' };
      campos.prod_lista = listaMap[String(mcx.LISTA)] || 'N';

      const tipMedMap = { '1': '1', '2': '3', '3': '2', '4': '5', '5': '4', '6': '6' };
      campos.class_med = tipMedMap[String(mcx.TIP_MED)] || '';

      const rtribStr = String(rtrib);
      if (rtribStr === '1') {
        campos.tributacao_monofasica = (mcx.CSTPIS_S === '04' || mcx.CSTPIS_S === '4') ? 'S' : 'N';
      } else {
        campos.tributacao_monofasica = (mcx.CSTPIS_E === '70' && (mcx.CSTPIS_S === '04' || mcx.CSTPIS_S === '4')) ? 'S' : 'N';
      }

      if (mcx.TP_ALIQICMS) {
        const norm = s => String(s).toUpperCase().trim();
        const tp   = norm(mcx.TP_ALIQICMS);
        let keyword = null;

        if (tp === 'T') {
          // Tributável: alíquota definida em Aliq_ICMS (ex: "12.00" → "12 %")
          if (mcx.Aliq_ICMS) {
            keyword = norm(Math.floor(parseFloat(mcx.Aliq_ICMS)) + ' %');
          }
        } else {
          const tpAliqMap = { 'F': 'ST', 'ST': 'ST', 'I': 'ISENTO', 'N': 'NAO TRIBUTAVEL' };
          keyword = tpAliqMap[tp] ? norm(tpAliqMap[tp]) : null;
        }

        if (keyword) {
          const trib = listaTributacao.find(t => norm(t.title) === keyword);
          if (trib) {
            campos.tributacao     = { id: trib.id, title: trib.title };
            campos.cod_tributacao = trib.id;
          }
        }
      }
    }
    return campos;
  }

  /* Normaliza os campos da tabela `revista` para o formato do formulário.
     Apenas inclui o campo se tiver valor não-nulo e não-vazio. */
  const mapRevista = (revista) => {
    const r = {};
    if (revista.DESCRICAO && revista.DESCRICAO.trim())
      r.produto = revista.DESCRICAO.trim().substring(0, 50).toUpperCase();
    if (revista.APRESENT && revista.APRESENT.trim())
      r.apresentacao = revista.APRESENT.trim();
    if (revista.PRUNIT && parseFloat(revista.PRUNIT) > 0)
      r.prod_prcompra = String(revista.PRUNIT);   // string com ponto decimal (ex: "72.26")
    if (revista.PRVEND && parseFloat(revista.PRVEND) > 0)
      r.prod_prvenda = String(revista.PRVEND);     // string com ponto decimal (ex: "99.6")
    if (revista.LISTA && revista.LISTA.trim())
      r.prod_lista = revista.LISTA.trim();
    return r;
  }

  /* Merge: começa com a base da revista, MCX sobrescreve somente
     onde retornar valor não-nulo e não-vazio. */
  const mergeComRevista = (revistaBase, camposMCX) => {
    const merged = { ...revistaBase };
    Object.entries(camposMCX).forEach(([k, v]) => {
      if (v !== null && v !== undefined && v !== '') {
        merged[k] = v;
      }
    });
    return merged;
  }

  const verificaCodBarras = (cod_barras) => {
    if (cod_barras !== '') {
      const url = settings.url + rotas.verificaCodBarras;
      const retorno = rest.get(url + '/?cod_barras=' + cod_barras);

      setLoadingBusca(true);

      retorno.then(ret => {
        if (ret.success != 'S') {
          form.cod_barras = '';
          setLoadingBusca(false);

          Swal.fire(
            'Atenção',
            ret.msg,
            'warning'
          );
        } else {
          // Dados da Revista (tabela de preços do cliente) — pode ser null
          const revistaBase = ret.revista ? mapRevista(ret.revista) : {};

          if (form.produto_id == '' && cod_barras !== '') {
            let dados = { "funcao": 'infoProdMCX', "ean": cod_barras }
            const retornoBusca = rest.post(rotas.buscaCadastro, dados);
            retornoBusca.then(ret => {
              setLoadingBusca(false);
              if (ret.success && ret.success == 'S') {
                if (ret.lista && ret.lista.ean) {
                  // MCX retornou dados: faz merge (MCX sobrescreve revista onde tiver valor)
                  const camposMCX = mapInfoProdMCX(ret.lista, ret.rtrib);
                  if (camposMCX.class_med) {
                    const found = listaClassifTipo.find(c => String(c.id) === String(camposMCX.class_med));
                    if (found) camposMCX.classe = found.title;
                  }
                  const campos = mergeComRevista(revistaBase, camposMCX);
                  setForm({ ...form, ...campos });
                  setRefresh(refresh + 1);
                } else if (Object.keys(revistaBase).length > 0) {
                  // MCX não encontrou o produto, mas a revista tem dados
                  setForm({ ...form, ...revistaBase });
                  setRefresh(refresh + 1);
                }
              } else if (Object.keys(revistaBase).length > 0) {
                // MCX falhou (erro), mas a revista tem dados — aplica o que tiver
                setForm({ ...form, ...revistaBase });
                setRefresh(refresh + 1);
              }
            })
          } else {
            setLoadingBusca(false);
          }
        }
      })
    }
  }

  const Ttip = () => {
    console.log(form.controle_medicamento);
    if (form.controle_medicamento === 'N') {
      return (

        // <Tooltip
        //   // {...args}
        //   autohide={true}
        //   flip={true}
        //   isOpen={tooltipOpen}
        //   target="TooltipExample"
        //   toggle={toggle}
        // >
        //   <div
        //     style={{ border: '2px solid', borderColor: 'red' }}
        //   >
        //     <strong>O NCM cadastrado no produto não pertence a um medicamento, verifique a aba classificação fiscal</strong>
        //   </div>
        // </Tooltip>
        <div>teste</div>
      )
    } else {
      return (
        <div>teste</div>
      )
    }
  }

  const listarEscalonado = () => {
    setListaEscalonado([]);

    const url = settings.url + rotas.listarEscalonado;
    const retorno = rest.get(url + '?produto_id=' + produto_id);

    retorno.then(ret => {
      if (ret.success === true) {
        let dEsc = [];

        ret.lista.map(produto => {
          let vUnit = produto.valor_pacote / produto.quantidade;
          let valor = produto.valor_pacote * 1;

          vUnit = vUnit.toFixed(2);
          valor = valor.toFixed(2);

          dEsc.push({
            desconto_escalonado_id: produto.desconto_escalonado_id,
            produto_id: produto.produto_id,
            leve: produto.quantidade,
            por: valor.replace('.', ','),
            valorUnidade: vUnit.replace('.', ',')
          })
        })
        setListaEscalonado(dEsc);
      }
    })
  }

  const adicionaEscalonado = () => {

    if (descontoEscalonado.qtde_escalonado == 0) {
      Swal.fire('Atenção',
        'Por favor preencha a quantidade!',
        'warning');
      return;
    }

    if (descontoEscalonado.preco_escalonado == 0) {
      Swal.fire('Atenção',
        'Por favor preencha o preço!',
        'warning');
      return;
    }

    if ((detProdExibicao.inicio_promocao == '')||
        (detProdExibicao.inicio_promocao == null)||
        (detProdExibicao.inicio_promocao == undefined)||
        (detProdExibicao.termino_promocao == '')||
        (detProdExibicao.termino_promocao == null)||
        (detProdExibicao.termino_promocao == undefined)) {
      Swal.fire('Atenção',
        'Por favor preencha o período de vigência da promoção!',
        'warning');
      return;
    }

    descontoEscalonado.preco_escalonado = Number(descontoEscalonado.preco_escalonado);
    descontoEscalonado.qtde_escalonado  = Number(descontoEscalonado.qtde_escalonado);

    if((Number((descontoEscalonado.preco_escalonado*100).toFixed(2)) % descontoEscalonado.qtde_escalonado)>0){

      let precoSugerido = (descontoEscalonado.preco_escalonado / descontoEscalonado.qtde_escalonado);
      precoSugerido = precoSugerido.toFixed(2);

      precoSugerido = Number(precoSugerido * descontoEscalonado.qtde_escalonado);
      Swal.fire('Atenção',
      'O valor da unidade precisa ser ajustada para evitar problemas de arredondamento, valor sugerido: R$ '+ precoSugerido,
      'warning');
    
      return;
    }

    const parametros = {
      produto_id: produto_id,
      quantidade: descontoEscalonado.qtde_escalonado,
      valor_pacote: descontoEscalonado.preco_escalonado
    }

    const url = settings.url + rotas.gravarEscalonado;
    const retorno = rest.put(url, parametros);

    retorno.then(ret => {
      if (ret.success === 'S') {
        descontoEscalonado.qtde_escalonado = 0;
        descontoEscalonado.preco_escalonado = 0;
        listarEscalonado();
        Swal.fire(
          'Sucesso',
          'Item adicionado com sucesso, aguarde integração',
          'success'
        )
      } else {
        Swal.fire(
          'Erro',
          'Erro ao adicionar registro!',
          'error'
        )
      }
    })
  }

  const removeEscalonado = (desconto_escalonado_id) =>{

    const parametros = {
      desconto_escalonado_id: desconto_escalonado_id
    }

    const url = settings.url + rotas.removeEscalonado;
    const retorno = rest.post(url, parametros); 

    retorno.then(ret=>{
      if(ret.success == 'S'){
        Swal.fire('Sucesso','Registro Removido com Sucesso!','success');
        listarEscalonado();
      }else{
        Swal.fire('Erro','Erro na Exclusão do Registro','error');
      }
    })
  }

  const setIsentoMS = (evt) => {
    if (evt.target.checked) {
      let frm = form;
      frm.registro_ms = 'ISENTO';
      setForm(frm);
      setRefresh(refresh + 1);
    } else {
      let frm = form;
      frm.registro_ms = '';
      setForm(frm);
      setRefresh(refresh + 1);
    }
  }

  const maxPague = (e) => {
    if (e.floatValue) {
      return (e.floatValue <= 10);
    } else {
      return (true)
    }
  }

  const maxLeve = (e) => {
    if (e.floatValue) {
      return (e.floatValue <= 15);
    } else {
      return (true)
    }
  }

  const bucarCadastro = (e) => {
    const codBarras = e.target.value;

    if (form.produto_id == '' && codBarras !== '') {
      setLoadingBusca(true);
      let dados = { "funcao": 'infoProdMCX', "ean": codBarras }
      const retorno = rest.post(rotas.buscaCadastro, dados);
      retorno.then(ret => {
        setLoadingBusca(false);
        if (ret.success && ret.success == 'S') {
          if (ret.lista && ret.lista.ean) {
            const campos = mapInfoProdMCX(ret.lista, ret.rtrib);
            if (campos.class_med) {
              const found = listaClassifTipo.find(c => String(c.id) === String(campos.class_med));
              if (found) campos.classe = found.title;
            }
            setForm({ ...form, ...campos });
            setRefresh(refresh + 1);
          }
        }
      })
    }
  }

  if (loading) {
    return (
      <ModalBody className="loadingBody">
        <Loading
          tipo='componente'
        />
      </ModalBody>
    )
  } else {

    //console.log(produtosRelacionados);

    return (
      <>
        {/* <SweetAlert
          show={sweetProps.show}
          type={sweetProps.type}
          style={{ display: "block", marginTop: "-100px" }}
          title={sweetProps.title}
          onConfirm={() => setSweet()}
          confirmBtnBsStyle="info"
        ></SweetAlert> */}
        {/* {console.log(ultCompras)} */}
        <FormGroup className="formCadastro">
          <ModalBody className="pb-0">
            <Nav pills className="nav-pills-default justify-content-center mb-3">
              <NavItem>
                <NavLink
                  className={activeTab === '1' ? 'active' : ''}
                  onClick={() => { toggleTab('1') }}
                >
                  Identificação
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={activeTab === '2' ? 'active' : ''}
                  onClick={() => { toggleTab('2'); }}
                >
                  Classificação Fiscal
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={activeTab === '3' ? 'active' : ''}
                  onClick={() => { toggleTab('3'); }}
                >
                  Detalhes/Promoção
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={activeTab === '4' ? 'active' : ''}
                  onClick={() => { toggleTab('4'); }}
                >
                  Informações Técnicas
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={activeTab === '5' ? 'active' : ''}
                  onClick={() => { toggleTab('5'); }}
                >
                  Últimas Compras
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={activeTab === '6' ? 'active' : ''}
                  onClick={() => { toggleTab('6'); }}
                >
                  Produtos Relacionados
                </NavLink>
              </NavItem>

            </Nav>

            <hr />

            {/* IDENTIFICAÇÃO */}
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1" key={refresh}>
                <Form>
                  <Row>
                    <Col md='2'>
                      <FormGroup>
                        <Label for="produto_id">Código</Label>
                        <Input
                          disabled
                          style={{ background: '#F9F9F9' }}
                          className="inputSM"
                          name="produto_id"
                          id="produto_id"
                          //onBlur={onChange('cod_barras')}
                          value={form.produto_id}
                        />
                      </FormGroup>
                    </Col>
                    <Col md='2'>
                      <FormGroup>
                        <Label for="cod_barras">
                          Cód Barras{' '}
                          {loadingBusca && <i className="fas fa-spinner fa-spin text-primary" style={{ fontSize: '0.8rem' }} />}
                        </Label>
                        <Input
                          className="inputSM"
                          name="cod_barras"
                          id="cod_barras"
                          onBlur={onChange('cod_barras')}
                          defaultValue={form.cod_barras}
                          required
                          invalid={form.cod_barras.length === 0}
                          maxLength={14}
                          valid={form.produto_id > 0 ? null : form.cod_barras.length > 0 ? true : false}
                        />
                        <FormFeedback>Preenchimento obrigatório</FormFeedback>
                      </FormGroup>
                    </Col>

                    <Col md='2'>
                      <FormGroup>
                        <Label for="cod_barras_hospitalar">Cód Bar Hospitalar</Label>
                        <Input
                          className="inputSM"
                          name="cod_barras_hospitalar"
                          id="cod_barras_hospitalar"
                          onBlur={onChange('cod_barras_hospitalar')}
                          defaultValue={form.cod_barras_hospitalar}
                          maxLength={14}
                        />
                      </FormGroup>
                    </Col>

                    <Col md='6'>
                      <FormGroup>
                        <Label for="produto">Produto</Label>
                        <Input
                          name="produto"
                          id="produto"
                          onBlur={onChange('produto')}
                          defaultValue={form.produto}
                          required
                          invalid={form.produto.length === 0 || form.produto.length > 50 ? true : false}
                          valid={form.produto_id > 0 || form.produto.length <= 50 ? null : form.produto.length > 0 ? true : false}
                        />
                        <FormFeedback>{form.produto_id > 0 || form.produto.length <= 50 ? 'Preenchimento obrigatório' : 'Nome muito longo (máx 50 caracteres)'}</FormFeedback>
                        {/* <FormText>Example help text that remains unchanged.</FormText> */}
                      </FormGroup>
                    </Col>

                  </Row>

                  <Row>
                    <Col md='12'>
                      <FormGroup>
                        <Label for="apresentacao">Apresentação</Label>
                        <Input
                          name="apresentcao"
                          id="apresentacao"
                          onBlur={onChange('apresentacao')}
                          defaultValue={form.apresentacao}
                          invalid={form.apresentacao.length > 50 ? true : false}
                        // valid={form.produto_id > 0 || form.produto.length <= 50 ? null : form.produto.length > 0 ? true : false}
                        />
                        <FormFeedback>{'Apresentação muito longa (máx 50 caracteres)'}</FormFeedback>
                      </FormGroup>
                    </Col>

                  </Row>

                  <Row>
                    <Col>
                      <FormGroup>
                        <ReactSelect
                          name="fornecedor"
                          label="Fornecedor"
                          placeholder="Selecione"
                          options={listaFornecedor}
                          defaultValue={{ id: form.fornecedor_id, title: form.fornecedor.title ? form.fornecedor.title : form.fornecedor }}
                          onChange={onChangeSelect('fornecedor')}
                          erro={form.fornecedor_id > 0 ? false : true}
                        >
                        </ReactSelect>
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        <ReactSelect
                          name="categoria"
                          label="Categoria"
                          placeholder="Selecione"
                          options={listaCategoria}
                          defaultValue={{ id: form.categoria_id, title: form.categoria.title ? form.categoria.title : form.categoria }}
                          onChange={onChangeSelect('categoria')}
                          erro={form.categoria_id > 0 ? false : true}
                        >
                        </ReactSelect>
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        <ReactSelect
                          name="subcategoria"
                          label="Subcategoria"
                          placeholder="Selecione"
                          options={listaSubcategoria}
                          defaultValue={{ id: form.subcategoria_id, title: form.subcategoria.title ? form.subcategoria.title : form.subcategoria }}
                          onChange={onChangeSelect('subcategoria')}
                        >
                        </ReactSelect>
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        <ReactSelect
                          name="prod_unidade"
                          label="Unidade de Medida"
                          placeholder="Selecione"
                          options={listaUnidade}
                          defaultValue={{ id: form.prod_unidade, title: form.prod_unidade }}
                          onChange={onChangeSelect('unidadeMedida')}
                          erro={form.unidadeMedida !== '' ? false : true}
                        >
                        </ReactSelect>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <FormGroup>
                        <ReactSelect
                          name="comissao"
                          label="Comissão"
                          placeholder="Selecione"
                          options={listaPadraoComissao}
                          defaultValue={{ id: form.padrao_comissao_id, title: form.padrao_comissao.title ? form.padrao_comissao.title : form.padrao_comissao + '%' }}
                          onChange={onChangeSelect('padrao_comissao')}
                          erro={form.padrao_comissao_id > 0 ? false : true}
                        >
                        </ReactSelect>
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        <ReactSelect
                          name="cod_tributacao"
                          label="Tributação"
                          placeholder="Selecione"
                          options={listaTributacao}
                          defaultValue={{ id: form.tributacao_id, title: form.tributacao.title ? form.tributacao.title : form.tributacao }}
                          onChange={onChangeSelect('tributacao')}
                          erro={form.tributacao_id > 0 ? false : form.tributacao ? false : true}
                        >
                        </ReactSelect>
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        <ReactSelect
                          name="grupo_compra"
                          label="Grupo Compra"
                          placeholder="Selecione"
                          options={listaGrupoCompras}
                          defaultValue={{ id: form.grupo_id, title: form.grupo }}
                          onChange={onChangeSelect('grupo_compra')}
                        >
                        </ReactSelect>
                      </FormGroup>
                    </Col>

                    <Col>                    
                      <FormGroup>
                        <ReactSelect
                          name="beneficio"
                          label="Beneficio"
                          placeholder="Selecione"
                          options={listaBeneficios}
                          defaultValue={{ id: form.beneficio_id, title: form.beneficio.title ? form.beneficio.title : form.beneficio }}
                          onChange={onChangeSelect('beneficio')}
                        >
                        </ReactSelect>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <FormGroup>
                        {/* <Label for="prod_prcompra">Pr. Compra</Label>
                        <Input
                          name="prod_prcompra"
                          id="prod_prcompra"
                          type="number"
                          onBlur={onChange('prod_prcompra')}
                          defaultValue={form.prod_prcompra}
                          invalid={form.prod_prcompra == 0 ? true : false}
                          valid={form.produto_id > 0 ? null : form.prod_prcompra > '0' ? true : false}
                        /> */}
                        <Label for="prod_prcompra">Pr. Compra</Label>
                        <NumberFormat
                          required
                          name="prod_prcompra"
                          id="prod_prcompra"
                          placeholder="0.00"
                          value={form.prod_prcompra.replace('.', ',')}
                          onChange={onChange('prod_prcompra')}
                          maxLength={20}
                          decimalScale={2}
                          allowNegative={false}
                          className={form.prod_prcompra == 0 ? "form-control is-invalid" : "form-control"}
                          prefix={"R$ "}
                          decimalSeparator={','}
                          fixedDecimalScale
                        />
                        <FormFeedback>Preenchimento obrigatório</FormFeedback>
                      </FormGroup>
                    </Col>

                    <Col
                      className={visiblePrVenda}
                    >
                      {/* <Label for="prod_prvenda">Pr. Venda</Label>
                      <Input
                        name="prod_prvenda"
                        id="prod_prvenda"
                        type="number"
                        onBlur={onChange('prod_prvenda')}
                        defaultValue={form.prod_prvenda}
                        invalid={form.prod_prvenda == 0 ? true : false}
                        valid={form.produto_id > 0 ? null : form.prod_prvenda > '0' ? true : false}
                      /> */}
                      <Label for="prod_prvenda">Pr. Venda</Label>
                      <NumberFormat
                        required
                        name="prod_prvenda"
                        id="prod_prvenda"
                        placeholder="0.00"
                        value={form.prod_prvenda.replace('.', ',')}
                        onChange={onChange('prod_prvenda')}
                        maxLength={20}
                        decimalScale={2}
                        allowNegative={false}
                        className={form.prod_prvenda == 0 ? "form-control is-invalid" : "form-control"}
                        prefix={"R$ "}
                        decimalSeparator={','}
                        fixedDecimalScale
                      />
                      <FormFeedback>Preenchimento obrigatório</FormFeedback>
                    </Col>

                    <Col>
                      <FormGroup>
                        {/* <Label for="prod_prpromocao">Pr. Promoção</Label>
                        <Input
                          name="prod_prpromocao"
                          id="prod_prpromocao"
                          type="number"
                          onBlur={onChange('prod_prpromocao')}
                          defaultValue={form.prod_prpromocao}
                        /> */}
                        <Label for="prod_prpromocao">Pr. Promoção</Label>
                        <NumberFormat
                          required
                          name="prod_prpromocao"
                          id="prod_prpromocao"
                          placeholder="0.00"
                          value={form.prod_prpromocao.replace('.', ',')}
                          onChange={onChange('prod_prpromocao')}
                          maxLength={20}
                          decimalScale={2}
                          allowNegative={false}
                          className={"form-control"}
                          prefix={"R$ "}
                          decimalSeparator={','}
                          fixedDecimalScale
                        />
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        {/* <Label for="prod_prcrediario">Pr. Crediário</Label>
                        <Input
                          name="prod_prcrediario"
                          id="prod_prcrediario"
                          type="number"
                          onBlur={onChange('prod_prcrediario')}
                          defaultValue={form.prod_prcrediario}
                        /> */}
                        <Label for="prod_prcrediario">Pr. Crediário</Label>
                        <NumberFormat
                          required
                          name="prod_prcrediario"
                          id="prod_prcrediario"
                          placeholder="0.00"
                          value={form.prod_prcrediario.replace('.', ',')}
                          onChange={onChange('prod_prcrediario')}
                          maxLength={20}
                          decimalScale={2}
                          allowNegative={false}
                          className={"form-control"}
                          prefix={"R$ "}
                          decimalSeparator={','}
                          fixedDecimalScale
                        />
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        <Label for="prod_estiminimo">Estoque Minimo</Label>
                        <NumberFormat
                          className="form-control"
                          name="prod_estiminimo"
                          id="prod_estiminimo"
                          type="text"
                          //mask="_"
                          // format="####"
                          decimalScale={0}
                          onBlur={onChange('prod_estminimo')}
                          defaultValue={form.prod_estminimo}
                        />
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        <Label for="hospitalar">Emb. Hospitalar</Label>
                        {/* <Input
                          name="hospitalar"
                          id="hospitalar"
                          onBlur={onChange('hospitalar')}
                          defaultValue={form.hospitalar} 
                          pattern="\d+"                       
                        /> */}
                        <NumberFormat
                          className="form-control"
                          name="hospitalar"
                          id="hospitalar"
                          type="text"
                          //mask="_"
                          format="####"
                          onChange={onChange('hospitalar')}
                          onBlur={alterouHospitalar}
                          onFocus={() => { setOldEmbHosp(form.hospitalar) }}
                          defaultValue={form.hospitalar}
                        />
                        {/* <NumberFormat
                                  //placeholder="CPF"
                                  type="text"
                                  mask="_"
                                  format="#.####.####.###-#"
                                  defaultValue={form.registro_ms}
                                  onChange={onChange('registro_ms')}
                                  disabled={checkControleEspecial}
                                  className={checkControleEspecial ? "form-control disabledCampo" : "form-control"}
                                /> */}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="card-2">
                    <Col>
                      <span className="tag-card">Tipo de preço</span>
                      <FormGroup className="mb-0">
                        <div className="form-check-radio">
                          <Label className="form-check-label">
                            <Input
                              onClick={tipoPreco}
                              type="radio"
                              name="exampleRadios"
                              id="monitorado"
                              value="option2"
                              defaultChecked={form.tipo_preco === 'M' ? true : false}
                            />
                            Monitorado
                            <span className="form-check-sign"></span>
                          </Label>
                        </div>

                        <div className="form-check-radio mb-0">
                          <Label className="form-check-label">
                            <Input
                              onClick={tipoPreco}
                              type="radio"
                              name="exampleRadios"
                              id="liberado"
                              value="option1"
                              defaultChecked={form.tipo_preco === 'L' ? true : false}
                            />
                            Liberado
                            <span className="form-check-sign"></span>
                          </Label>
                        </div>
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup className="mb-0">
                        {loadingMkp ? <Loading tipo='componente'></Loading> :
                          <>
                            <Label for="markup">% Markup</Label>
                            <Input
                              name="markup"
                              id="markup"
                              className={disabledMarkup ? 'disabledCampo' : ''}
                              onFocus={focusMarkup}
                              onBlur={calculaMKP}
                              onChange={onChange('margem_lucro')}
                              defaultValue={form.margem_lucro}
                              disabled={disabledMarkup}
                            />
                          </>
                        }
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup className="mb-0">
                        <Label for="valor_ult_compra">Valor Ult Compra</Label>
                        <NumberFormat
                          required
                          name="valor_ult_compra"
                          id="valor_ult_compra"
                          placeholder="0.00"
                          value={form.valor_ult_compra.replace('.', ',')}
                          onChange={onChange('valor_ult_compra')}
                          maxLength={20}
                          decimalScale={2}
                          allowNegative={false}
                          className={(disabledUltCompra) ? "form-control disabledCampo" : "form-control"}
                          // className={"form-control disabledCampo"}
                          prefix={"R$ "}
                          decimalSeparator={','}
                          fixedDecimalScale
                          disabled={disabledUltCompra}
                        />
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup className="mb-0">
                        {/* <Label for="desconto_maximo">% Desconto Máximo</Label>
                        <Input
                          name="desconto_maximo"
                          id="desconto_maximo"
                          type="number"
                          onBlur={onChange('desconto_maximo')}
                          defaultValue={form.desconto_maximo}
                        /> */}
                        <Label for="desconto_maximo">Desconto Máximo</Label>
                        <NumberFormat
                          required
                          name="desconto_maximo"
                          id="desconto_maximo"
                          placeholder="0.00"
                          value={form.desconto_maximo.replace('.', ',')}
                          onChange={onChange('desconto_maximo')}
                          maxLength={20}
                          decimalScale={2}
                          allowNegative={false}
                          className={"form-control"}
                          suffix={"%"}
                          decimalSeparator={','}
                          fixedDecimalScale
                        />
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup className="mb-0">
                        {/* <Label for="cmv">CMV</Label>
                        <Input
                          name="cmv"
                          id="cmv"
                          type="number"
                          onBlur={onChange('prod_cmv')}
                          defaultValue={form.prod_cmv}
                        /> */}
                        <Label for="prod_cmv">CMV</Label>
                        <NumberFormat
                          required
                          name="prod_cmv"
                          id="prod_cmv"
                          placeholder="0.00"
                          value={form.prod_cmv.replace('.', ',')}
                          onChange={onChange('prod_cmv')}
                          maxLength={20}
                          decimalScale={2}
                          allowNegative={false}
                          className={"form-control disabledCampo"}
                          prefix={"R$ "}
                          decimalSeparator={','}
                          fixedDecimalScale
                          disabled
                        />
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup className="mb-0">
                        <Label for="margem_apurada">% Margem Apurada</Label>
                        <Input
                          className='disabledCampo'
                          name="margem_apurada"
                          id="margem_apurada"
                          defaultValue={calculaMargemApurada()}
                          disabled
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="card-2">
                    <Col>
                      <span className="tag-card">Farmácia Popular</span>
                      <FormGroup className="mb-0">
                        {/* <Label for="preco_f_popular">Preço</Label>
                        <Input
                          name="preco_f_popular"
                          id="preco_f_popular"
                          type="number"
                          onBlur={onChange('prod_prfarmapop')}
                          defaultValue={form.prod_prfarmapop}
                        /> */}
                        <Label for="prod_prfarmapop">Preço Farmácia Popular</Label>
                        <NumberFormat
                          required
                          name="prod_prfarmapop"
                          id="prod_prfarmapop"
                          placeholder="0.00"
                          value={form.prod_prfarmapop.replace('.', ',')}
                          onChange={onChange('prod_prfarmapop')}
                          maxLength={20}
                          decimalScale={2}
                          allowNegative={false}
                          className={"form-control"}
                          prefix={"R$ "}
                          decimalSeparator={','}
                          fixedDecimalScale
                        />
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup className="mb-0">
                        <Label for="comp_ml">Preço Bolsa Família</Label>
                        <NumberFormat
                          fixedDecimalScale
                          name="prod_prfarmapop_bf"
                          id="prod_prfarmapop_bf"
                          placeholder="0.00"
                          maxLength={20}
                          decimalScale={2}
                          allowNegative={false}
                          className={"form-control"}
                          prefix={"R$ "}
                          decimalSeparator={','}
                          value={form.prod_prfarmapop_bf.replace('.', ',')}
                          onChange={onChange('prod_prfarmapop_bf')}
                        />
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup className="mb-0">
                        <Label for="comp_ml">Qtde. Comp/ML</Label>
                        {/* <Input
                          name="comp_ml"
                          id="comp_ml"
                          onBlur={onChange('quant_comp_ml')}
                          defaultValue={form.quant_comp_ml}
                        /> */}
                        <NumberFormat
                          className="form-control"
                          name="comp_ml"
                          id="comp_ml"
                          type="text"
                          //mask="_"
                          format="####"
                          onBlur={onChange('quant_comp_ml')}
                          defaultValue={form.quant_comp_ml}
                        />
                      </FormGroup>
                    </Col>


                    <Col className="mt-3">
                      <FormGroup check inline className="mb-0">
                        <Label check>
                          <Input
                            type="checkbox"
                            id="gerar_comissao_fp"
                            onClick={onChange('gerar_comissao_fp')}
                            defaultChecked={form.gerar_comissao_fp === 'S' ? true : false}
                          />
                          <span className="form-check-sign" />Gerar Comissão F. Popular
                        </Label>
                      </FormGroup>{" "}
                      <FormGroup check inline className="mb-0">
                        <Label check>
                          <Input
                            type="checkbox"
                            id="autorizado_fpbf"
                            onClick={onChange('autorizado_fpbf')}
                            defaultChecked={form.autorizado_fpbf === 'S' ? true : false}
                          />
                          <span className="form-check-sign" />Habilitar Bolsa Família
                        </Label>
                      </FormGroup>{" "}
                    </Col>
                  </Row>

                  {/* STATUS DO PRODUTO */}
                  <Row>
                    <Col md='6'>
                      <Row className="card-2 pb-3 pt-4">
                        <Col className="d-flex flex-column">
                          <span className="tag-card">Status do Produto</span>

                          <FormGroup check inline className="mt-2">
                            <Label check>
                              <Input
                                type="checkbox"
                                id="prod_ativo"
                                onClick={onChange('prod_ativo')}
                                defaultChecked={form.prod_ativo === 'S' ? true : false}
                              />
                              <span className="form-check-sign" />Produto Ativo
                            </Label>
                          </FormGroup>{" "}



                          <FormGroup check inline className="mt-2">
                            <Label check>
                              <Input
                                type="checkbox"
                                id='atualizar_preco'
                                onClick={onChange('atualizar_preco')}
                                defaultChecked={form.atualizar_preco === 'S' ? true : false}
                              />{' '}
                              <span className="form-check-sign" />Atualizar Preços Automaticamente
                            </Label>
                          </FormGroup>{" "}

                          <FormGroup check inline className="mt-2">
                            <Label check>
                              <Input
                                type="checkbox"
                                id='uso_consumo'
                                onClick={clickUso}
                                onChange={onChange('uso_consumo')}
                                defaultChecked={form.uso_consumo === 'S' ? true : false}
                              />{' '}
                              <span className="form-check-sign" />Material de uso e consumo
                            </Label>
                          </FormGroup>

                          <FormGroup check inline className="mt-2">
                            <Label check>
                              <Input
                                type="checkbox"
                                id='uso_continuo'
                                onClick={clickUso}
                                onChange={onChange('uso_continuo')}
                                defaultChecked={form.uso_continuo === 'S' ? true : false}
                              />{' '}
                              <span className="form-check-sign" />Uso Contínuo
                            </Label>
                          </FormGroup>


                          <FormGroup className="">
                            <Label for="duracao">Duração</Label>
                            <Input
                              id="duracao"
                              name="duracao"
                              onBlur={onChange('duracao')}
                              defaultValue={form.duracao}
                              disabled={form.uso_continuo === 'S' ? false : true}
                              className={form.uso_continuo === 'S' ? '' : "disabledCampo"}
                            />
                          </FormGroup>

                          
                        </Col>
                      </Row>
                    </Col>
                    {/* STATUS DO PRODUTO end */}

                    {/* CONTROLE ESPECIAL */}

                    {/* <Tooltip
                      // {...args}
                      autohide={true}
                      flip={true}
                      isOpen={tooltipOpen}
                      target="vinicius"
                      toggle={toggle}
                    >
                      <div
                        style={{ border: '2px solid', borderColor: 'red' }}
                      >
                        <strong>O NCM cadastrado no produto não pertence a um medicamento, verifique a aba classificação fiscal</strong>
                      </div>
                    </Tooltip> */}
                    <Col
                      md="6"
                      style={{ cursor: form.controle_medicamento === 'N' ? "not-allowed" : "" }}
                      
                    >
                      <Row
                        className="card-2"
                      >
                        {/* <Ttip></Ttip> */}
                        
                        <Col>
                          <span className="tag-card">
                            <FormGroup check inline className="mb-0">
                              <Label check>
                                <Input
                                  type="checkbox"
                                  name="controle"
                                  id="controle"
                                  checked={form.controle_medicamento === 'S' ? true : false}
                                  onChange={onChange('controle_medicamento')}
                                // onClick={clickControle}
                                // disabled
                                />
                                <span className="form-check-sign" />Controle de Medicamentos
                              </Label>
                            </FormGroup>{" "}
                          </span>

                          <Row>
                          
                            <Col md="6">
                              <div className="card-2">
                                <FormGroup
                                  className="mb-0"
                                >
                                  <div className="form-check-radio" >
                                    <Label className="form-check-label">
                                      <Input
                                        type="radio"
                                        name="controle-especial"
                                        id="psicotropico"
                                        value="C"
                                        checked={form.controle == 'C' ? true : false}
                                        onChange={onChange('controle')}
                                        // onClick={clickPsiAnt}
                                        disabled={form.controle_medicamento === 'N' ? true : false}
                                      />
                                      Psicotrópico
                                      <span className="form-check-sign"></span>
                                    </Label>
                                  </div>

                                  <div className="form-check-radio" >
                                    <Label className="form-check-label">
                                      <Input
                                        type="radio"
                                        name="controle-especial"
                                        id="antimicrobiano"
                                        value="A"
                                        checked={form.controle == 'A' ? true : false}
                                        onChange={onChange('controle')}
                                        // onClick={clickPsiAnt}
                                        disabled={form.controle_medicamento === 'N' ? true : false}
                                      />
                                      Antimicrobiano
                                      <span className="form-check-sign"></span>
                                    </Label>
                                  </div>

                                  <div className="form-check-radio mb-0" >
                                    <Label className="form-check-label">
                                      <Input
                                        type="radio"
                                        name="controle-especial"
                                        id="sem-controle-especial"
                                        value=""
                                        checked={form.controle == '' ? true : false}
                                        onChange={onChange('controle')}
                                        // onClick={clickPsiAnt}
                                        disabled={form.controle_medicamento === 'N' ? true : false}
                                      />
                                      Sem Controle Esp.
                                      <span className="form-check-sign"></span>
                                    </Label>
                                  </div>

                                </FormGroup>
                              </div>
                            </Col>

                            <Col md="6">
                              <div className="card-2">
                                <FormGroup className="mb-0">
                                  <span className="tag-card-inCard">Unidade de medida</span>
                                  <div className="form-check-radio" >
                                    <Label className="form-check-label">
                                      <Input
                                        type="radio"
                                        name="sngpc-unidade"
                                        id="caixa"
                                        value="1"
                                        checked={form.sngpc_unidade == '1' ? true : false}
                                        onChange={onChange('sngpc_unidade')}
                                        //onClick={clickPsiAnt}
                                        disabled={(form.psicotropico === 'N' && form.antimicrobiano === 'N') ? true : false}
                                      />
                                      Caixa
                                      <span className="form-check-sign"></span>
                                    </Label>
                                  </div>

                                  <div className="form-check-radio mb-0" >
                                    <Label className="form-check-label">
                                      <Input
                                        type="radio"
                                        name="sngpc-unidade"
                                        id="frasco"
                                        value="2"
                                        checked={form.sngpc_unidade == '2' ? true : false}
                                        onChange={onChange('sngpc_unidade')}
                                        //onClick={clickPsiAnt}
                                        disabled={(form.psicotropico === 'N' && form.antimicrobiano === 'N') ? true : false}
                                      />
                                      Frasco
                                      <span className="form-check-sign"></span>
                                    </Label>
                                  </div>
                                </FormGroup>
                              </div>
                            </Col>

                            <Col md="6">
                              <FormGroup className="mb-0">
                                <Label for="reg-ms">Registro MS</Label>
                                <NumberFormat
                                  //placeholder="CPF"
                                  type="text"
                                  mask="_"
                                  format="#.####.####.###-#"
                                  // format={testeEdit}
                                  value={form.registro_ms}
                                  onChange={onChange('registro_ms')}
                                  disabled={(form.controle_medicamento === 'N' || form.registro_ms === 'ISENTO') ? true : false}
                                  className={(form.controle_medicamento === 'N' || form.registro_ms === 'ISENTO') ? "form-control disabledCampo" : "form-control"}
                                />
                              </FormGroup>
                              {/* <FormGroup className="card-2"> */}
                              <FormGroup check inline className="mb-0 mt-2">
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    id="isento-ms"
                                    onClick={setIsentoMS}
                                    checked={((form.registro_ms === 'ISENTO') && (form.controle_medicamento === 'S')) ? true : false}
                                    disabled={(form.psicotropico === 'S' || form.antimicrobiano === 'S' || form.controle_medicamento === 'N') ? true : false}
                                  //disabled
                                  />
                                  <span className="form-check-sign" />Isento de Registro MS
                                </Label>
                              </FormGroup>{" "}
                              {/* </FormGroup> */}
                            </Col>

                            {
                              loadingLista ?
                                <Loading tipo='componente'></Loading>
                                :
                                <Col md="6">
                                  <FormGroup className="mb-0">
                                    <ReactSelect
                                      name="lista"
                                      label="Lista"
                                      placeholder="Selecione"
                                      options={listaPsicotropico}
                                      defaultValue={{
                                        id: form.listaPsicotropico ? form.listaPsicotropico.id : form.lista,
                                        title: form.listaPsicotropico ? form.listaPsicotropico.id : form.lista
                                      }}
                                      onChange={onChangeSelect('listaPsicotropico')}
                                      isDisabled={disabledLista}
                                      erro={checaListaPsicotropico()}
                                    >
                                    </ReactSelect>
                                  </FormGroup>
                                </Col>
                            }

                            <span id="vinicius" hidden={!tooltipOpen} className='form-check-sign text-danger ml-3 mt-2' style={{fontSize:'12px'}}>
                              O <strong>NCM</strong> não é de medicamento, verifique a aba <strong> CLASSIFICAÇÃO FISCAL</strong>
                            </span>

                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    {/* CONTROLE ESPECIAL end */}
                  </Row>

                </Form>
              </TabPane>
            </TabContent>

            {/* CLASSIFICAÇÃO FISCAL */}
            <TabContent activeTab={activeTab}>
              <TabPane tabId="2" key={refresh}>
                <Form>
                  <Row>
                    <Col md="3">
                      <div className="card-2">
                        <span className="tag-card-div">Lista</span>

                        <FormGroup className="form-check-radio">
                          <Label className="form-check-label">
                            <Input
                              onClick={() => { setLista('+') }}
                              type="radio"
                              name="exampleRadios"
                              id="positiva"
                              value="option2"
                              defaultChecked={form.prod_lista === '+' ? true : false}
                            />
                            Positiva
                            <span className="form-check-sign"></span>
                          </Label>
                        </FormGroup>

                        <FormGroup className="form-check-radio">
                          <Label className="form-check-label">
                            <Input
                              onClick={() => { setLista('-') }}
                              type="radio"
                              name="exampleRadios"
                              id="negativa"
                              value="option1"
                              defaultChecked={form.prod_lista === '-' ? true : false}
                            />
                            Negativa
                            <span className="form-check-sign"></span>
                          </Label>
                        </FormGroup>

                        <FormGroup className="form-check-radio">
                          <Label className="form-check-label">
                            <Input
                              onClick={() => { setLista('N') }}
                              type="radio"
                              name="exampleRadios"
                              id="neutra"
                              value="option2"
                              defaultChecked={form.prod_lista === 'N' ? true : false}
                            />
                            Neutra
                            <span className="form-check-sign"></span>
                          </Label>
                        </FormGroup>

                        <FormGroup className="form-check-radio">
                          <Label className="form-check-label">
                            <Input
                              onClick={() => { setLista('') }}
                              type="radio"
                              name="exampleRadios"
                              id="nenhuma"
                              value="option1"
                              defaultChecked={form.prod_lista === '' ? true : false}
                            />
                            Nenhuma
                            <span className="form-check-sign"></span>
                          </Label>
                        </FormGroup>
                      </div>
                    </Col>

                    <Col md="3">
                      <FormGroup>
                        <Label for="cst_pis">CST PIS</Label>
                        <Input
                          name="cst_pis"
                          id="cst_pis"
                          maxLength="2"
                          onChange={onChange('cst_pis')}
                          onBlur={validaNumero}
                          defaultValue={form.cst_pis}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label for="cst_cofins">CST COFINS</Label>
                        <Input
                          name="cst_cofins"
                          id="cst_cofins"
                          maxLength="2"
                          onChange={onChange('cst_cofins')}
                          onBlur={validaNumero}
                          defaultValue={form.cst_cofins}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label for="natureza_receita">Nat. Rec. Pis Cofins</Label>
                        <Input
                          name="natureza_receita"
                          id="natureza_receita"
                          maxLength="3"
                          onChange={onChange('natureza_receita_pis_cofins')}
                          onBlur={validaNumero}
                          defaultValue={form.natureza_receita_pis_cofins}
                        />
                      </FormGroup>
                    </Col>

                    <Col md="3">
                      <FormGroup>
                        <Label for="ncm">NCM</Label>
                        <Input
                          name="ncm"
                          id="ncm"
                          maxLength="8"
                          onChange={onChange('ncm')}
                          onBlur={validaNumero}
                          defaultValue={form.ncm}
                          required
                          // invalid={form.ncm.length < 8 ? true : false}
                          // valid={form.produto_id > 0 ? null : form.ncm.length === 8 ? true : false}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="imposto_aliq">% Alíquota NCM</Label>
                        <Input
                          name="imposto_aliq"
                          id="imposto_aliq"
                          type="text"
                          maxLength="5"
                          onChange={onChange('imposto_aliq')}
                          onBlur={validaNumero}
                          // onBlur        = {}
                          defaultValue={form.imposto_aliq.toLocaleString('pt-br', { style: 'percent', currency: 'BRL' })}
                          // defaultValue={form.imposto_aliq}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="cest">CEST</Label>
                        <Input
                          name="cest"
                          id="cest"
                          maxLength="7"
                          onBlur={validaNumero}
                          onChange={onChange('cest')}
                          defaultValue={form.cest}
                          required
                          // invalid={validaCest() !== null ? !validaCest() : null}
                          // valid={form.produto_id > 0 ? null : validaCest()}
                        />
                        <FormFeedback>Preenchimento obrigatório</FormFeedback>
                      </FormGroup>
                    </Col>

                    <Col md="3">

                      <FormGroup>
                        <Label for="desonerado">% Aliq. ICMS Desonerado</Label>
                        <Input
                          name="desonerado"
                          id="desonerado"
                          maxLength="7"
                          onChange={onChange('aliq_icms_deson')}
                          defaultValue={form.aliq_icms_deson}
                        />
                      </FormGroup>

                      <FormGroup>
                        <ReactSelect
                          name="classif_tipo"
                          label="Classificação"
                          placeholder="Selecione"
                          options={listaClassifTipo}
                          defaultValue={{ id: form.class_med, title: form.classe }}
                          onChange={onChangeSelect('classif_tipo')}
                        >
                        </ReactSelect>
                      </FormGroup>

                      <FormGroup className="card-2">
                        <FormGroup check inline className="mb-0">
                          <Label check>
                            <Input
                              type="checkbox"
                              id="tributacao_monofasica"
                              onClick={setTributacaoMonofasica}
                              defaultChecked={form.tributacao_monofasica === 'S' ? true : false}
                            />
                            <span className="form-check-sign" />Tributação Monofásica
                          </Label>
                        </FormGroup>{" "}
                      </FormGroup>

                    </Col>
                  </Row>
                </Form>
              </TabPane>
            </TabContent>

            {/* detalhes / promocao */}
            <TabContent activeTab={activeTab}>
              <TabPane tabId="3">

                <Row>
                  <Col className="pl-0">
                    <ReactSelect
                      name="Lojas"
                      label="Lojas"
                      placeholder="Selecione"
                      options={listaLojasDetPromo}
                      defaultValue={listaLojasDetPromo.length > 0 ? { id: listaLojasDetPromo[0].id, title: listaLojasDetPromo[0].title } : {}}
                      onChange={onChangeLojasDetPromo}
                      className="mb-4"
                    >
                    </ReactSelect>
                  </Col>
                </Row>

                <Form>
                  <Row>
                    <Col
                      className="p-0 d-flex"
                      md="6"
                    >
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <Label for="prod_estiminimo">Pr.Venda</Label>
                            <NumberFormat
                              required
                              name="preco_venda"
                              id="preco_venda"
                              placeholder="0,00"
                              value={detProdExibicao.prod_prvenda.replace('.', ',')}
                              onBlur={onChangeDetPromo('prod_prvenda')}
                              maxLength={20}
                              decimalScale={2}
                              allowNegative={false}
                              className={configFieldDetPromo.prod_prvenda ? "form-control disabledCampo" : "form-control"}
                              prefix={"R$ "}
                              decimalSeparator={','}
                              fixedDecimalScale
                              disabled={configFieldDetPromo.prod_prvenda}
                            />
                          </FormGroup>
                        </Col>

                        <Col md="6">
                          <FormGroup>
                            <Label for="promocao_permanente">Desc. Promoção Perm.</Label>
                            <NumberFormat
                              required
                              name="promocao_permanente"
                              id="promocao_permanente"
                              placeholder="0%"
                              value={detProdExibicao.promocao_permanente.replace('.', ',')}
                              onBlur={onChangeDetPromo('promocao_permanente')}
                              maxLength={20}
                              decimalScale={2}
                              allowNegative={false}
                              className={configFieldDetPromo.promocao_permanente ? "form-control disabledCampo" : "form-control"}
                              suffix={"%"}
                              decimalSeparator={','}
                              fixedDecimalScale
                              disabled={configFieldDetPromo.promocao_permanente}
                            />
                          </FormGroup>
                        </Col>

                        <Col md="6">
                          <FormGroup>
                            <Label for="preco_promocao">Preço de Promoção</Label>
                            <NumberFormat
                              required
                              name="prod_prpromocao"
                              id="prod_prpromocao"
                              placeholder="0,00"
                              value={detProdExibicao.prod_prpromocao.replace('.', ',')}
                              onBlur={onChangeDetPromo('prod_prpromocao')}
                              maxLength={20}
                              decimalScale={2}
                              allowNegative={false}
                              className={configFieldDetPromo.prod_prpromocao ? "form-control disabledCampo" : "form-control"}
                              prefix={"R$ "}
                              decimalSeparator={','}
                              fixedDecimalScale
                              disabled={configFieldDetPromo.prod_prpromocao}
                            />
                          </FormGroup>
                        </Col>

                        <Col md="6">
                          <FormGroup>
                            <Label for="preco_crediario">Preço de Crediário</Label>
                            <NumberFormat
                              required
                              name="prod_prcrediario"
                              id="prod_prcrediario"
                              placeholder="0,00"
                              value={detProdExibicao.prod_prcrediario.replace('.', ',')}
                              onBlur={onChangeDetPromo('prod_prcrediario')}
                              maxLength={20}
                              decimalScale={2}
                              allowNegative={false}
                              className={configFieldDetPromo.prod_prcrediario ? "form-control disabledCampo" : "form-control"}
                              prefix={"R$ "}
                              decimalSeparator={','}
                              fixedDecimalScale
                              disabled={configFieldDetPromo.prod_prcrediario}
                            />
                          </FormGroup>
                        </Col>

                      </Row>
                    </Col>


                    <Col md="6">
                      <Row className="card-2 pb-3 pt-4">
                        <Col className="d-flex">
                          <span className="tag-card">Promoção Pague X Leve</span>
                          <Row>
                            <Col md="4">
                              <FormGroup>
                                <Label for="promocao_pague">Pague</Label>
                                <NumberFormat
                                  required
                                  name="promocao_pague"
                                  id="promocao_pague"
                                  placeholder="0"
                                  value={detProdExibicao.promocao_pague.replace('.', ',')}
                                  onBlur={onChangeDetPromo('promocao_pague')}
                                  maxLength={2}
                                  decimalScale={0}
                                  allowNegative={false}
                                  className={configFieldDetPromo.promocao_pague ? "form-control disabledCampo" : "form-control"}
                                  prefix={""}
                                  decimalSeparator={','}
                                  fixedDecimalScale
                                  disabled={configFieldDetPromo.promocao_pague}
                                  isAllowed={maxPague}
                                />
                              </FormGroup>
                            </Col>

                            <Col md="4">
                              <FormGroup>
                                <Label for="promocao_leve">Leve</Label>
                                <NumberFormat
                                  required
                                  name="promocao_leve"
                                  id="promocao_leve"
                                  placeholder="0"
                                  value={detProdExibicao.promocao_leve}
                                  onBlur={onChangeDetPromo('promocao_leve')}
                                  // maxLength={2}
                                  decimalScale={0}
                                  allowNegative={false}
                                  className={configFieldDetPromo.promocao_leve ? "form-control disabledCampo" : "form-control"}
                                  prefix={""}
                                  decimalSeparator={','}
                                  fixedDecimalScale
                                  disabled={configFieldDetPromo.promocao_leve}
                                  isAllowed={maxLeve}
                                />
                              </FormGroup>
                            </Col>

                            <Col
                              md="4"
                            >
                              <div className="card-2">
                                <span className="tag-card-div">Utilizar PR.</span>
                                <FormGroup
                                  className="form-check-radio"
                                >
                                  <Label className="form-check-label">

                                    <Input
                                      onClick={onChangeDetPromo('tipo_preco_promocao_pl')}
                                      type="radio"
                                      name="tipo_preco_promocao_pl"
                                      id="V"
                                      value="option2"
                                      // defaultChecked={true}
                                      checked={detProdExibicao.tipo_preco_promocao_pl === 'V' ? true : false}
                                      disabled={configFieldDetPromo.tipo_preco_promocao_pl}
                                    />
                                    Venda
                                    <span className="form-check-sign"></span>
                                  </Label>
                                </FormGroup>

                                <FormGroup className="form-check-radio">
                                  <Label className="form-check-label">
                                    <Input
                                      onClick={onChangeDetPromo('tipo_preco_promocao_pl')}
                                      type="radio"
                                      name="tipo_preco_promocao_pl"
                                      id="P"
                                      value="option2"
                                      checked={detProdExibicao.tipo_preco_promocao_pl === 'P' ? true : false}
                                      disabled={configFieldDetPromo.tipo_preco_promocao_pl}
                                    />
                                    Promoção
                                    <span className="form-check-sign"></span>
                                  </Label>
                                </FormGroup>

                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                  </Row>



                  <Row>
                    <Col md="6" className="px-0">
                      <Row className="card-2 pb-3 pt-4">
                        <Col className="d-flex">
                          <span className="tag-card">Desconto Escalonado</span>
                          <Row>

                            <Col md="4">
                              <FormGroup>
                                <Label for="qtde_escalonado">Qtde</Label>
                                <NumberFormat
                                  className="form-control"
                                  name="qtde_escalonado"
                                  id="qtde_escalonado"
                                  type="text"
                                  //mask="_"
                                  format="#"
                                  onBlur={onChangeEscalonado('qtde_escalonado')}
                                // defaultValue={form.prod_estminimo}
                                  disabled = {configFieldDetPromo.desconto_escalonado.quantidade}
                                />
                              </FormGroup>
                            </Col>

                            <Col md="4">
                              <FormGroup>
                                <Label for="preco_escalonado">Preço</Label>
                                <NumberFormat
                                  className="form-control"
                                  name="preco_escalonado"
                                  id="preco_escalonado"
                                  type="text"
                                  placeholder="0,00"
                                  //mask="_"
                                  // format="R$ ###,##"
                                  prefix={"R$ "}
                                  decimalSeparator={','}
                                  onBlur={onChangeEscalonado('preco_escalonado')}
                                // defaultValue={form.prod_estminimo}
                                  disabled = {configFieldDetPromo.desconto_escalonado.valor_pacote}
                                />
                              </FormGroup>
                            </Col>

                            <Col md="4" className="d-flex align-items-end">
                           
                              <Button
                                onClick = {adicionaEscalonado}
                                disabled = {configFieldDetPromo.desconto_escalonado.valor_pacote}
                              >Adicionar
                              </Button>
                              
                            </Col>
                    
                              <Col>                                
                                <Table
                                  bordered
                                >
                                  <thead className="text-default">
                                    <tr>
                                      <th>Leve</th>
                                      <th>Por</th>
                                      <th>Valor Unidade</th>
                                      <th className="text-center" style={{ width: "15%" }}>Excluir</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {listaEscalonado.map(produto =>
                                      <tr
                                        key={produto.desconto_escalonado_id}
                                      >
                                        <td>{produto.leve}</td>
                                        <td>{produto.por}</td>
                                        <td>{produto.valorUnidade}</td>
                                        <td className="text-center">
                                          <Button
                                            className="btn-icon btn-neutral"
                                            color="danger"
                                            id=""
                                            size="md"
                                            type="button"
                                            disabled = {configFieldDetPromo.desconto_escalonado.valor_pacote}
                                            onClick={() => { removeEscalonado(produto.desconto_escalonado_id) }}
                                          >
                                            <i className="fas fa-times" />
                                          </Button>{" "}
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                              </Col>                            
                          </Row>
                        </Col>
                      </Row>                  
                    </Col>

                    <Col className="mt-3">
                      <Row className="mt-2">
                        <Col md="12">
                          <FormGroup check inline >
                            <Label check>
                              <Input
                                type="checkbox"
                                id="promocao_vista"
                                onClick={onChangeDetPromo('promocao_vista')}
                                checked={detProdExibicao.promocao_vista === 'S' ? true : false}
                                disabled={configFieldDetPromo.promocao_vista}
                              />
                              <span className="form-check-sign" />Aplicar Promoção nas Vendas à Vista e Convênios Especiais
                            </Label>
                          </FormGroup>{" "}

                          <FormGroup check inline className="mb-0">
                            <Label check>
                              <Input
                                type="checkbox"
                                id="promocao_convenio"
                                onClick={onChangeDetPromo('promocao_convenio')}
                                checked={detProdExibicao.promocao_convenio === 'S' ? true : false}
                                disabled={configFieldDetPromo.promocao_convenio}
                              />
                              <span className="form-check-sign" />Aplicar Promoção nas Vendas Para Crediário
                            </Label>
                          </FormGroup>{" "}
                        </Col>

                        <Col md="12" >
                          <Row className="pl-2 mt-3">
                            <Col md="6" className="pl-2">
                              <FormGroup>
                                <Label for="tabloide_id">Inicio Promoção</Label>
                                <DateTime
                                  value={detProdExibicao.inicio_promocao}
                                  dateFormat="DD/MM/YYYY"
                                  //dateFormat='YYYY-MM-DD'
                                  onChange={onChangeDateDet('inicio_promocao')}
                                  timeFormat={false}
                                  closeOnSelect={true}
                                  inputProps={{ disabled: configFieldDetPromo.inicio_promocao }}
                                >

                                </DateTime>
                              </FormGroup>
                            </Col>

                            <Col md="6">
                              <FormGroup>                            
                                <Label for="tabloide_id">Término Promoção</Label>
                                <DateTime
                                  value={detProdExibicao.termino_promocao}
                                  dateFormat="DD/MM/YYYY"
                                  //dateFormat='YYYY-MM-DD'
                                  onChange={onChangeDateDet('termino_promocao')}
                                  timeFormat={false}
                                  closeOnSelect={true}
                                  inputProps={{ disabled: configFieldDetPromo.termino_promocao }}
                                >

                                </DateTime>
                              </FormGroup>
                            </Col>
                          </Row>
                        
                        </Col>
                      </Row>
                    </Col>




                  </Row>

                </Form>
              </TabPane>
            </TabContent>

            {/* INFORMAÇÕES TÉCNICAS */}
            <TabContent activeTab={activeTab}>
              <TabPane tabId="4">
                <Form>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <ReactSelect
                          name="prod_substancia"
                          label="Substância"
                          placeholder="Selecione"
                          options={listaSubstancia}
                          //defaultValue= {form.substancia}
                          onChange={onChangeSubstancia}
                        >
                        </ReactSelect>
                      </FormGroup>

                      <Button
                        className="float-right mt-0"
                        size="sm"
                        color="success"
                        onClick={() => { gravaNovaSubstancia() }}
                      >
                        Adicionar
                      </Button>
                    </Col>

                    <Col md="8">
                      {
                        listaSubstanciaProduto.length === 0
                          ?
                          <div className="card-2 selectSubstancia">Selecione as substâncias...</div>
                          :
                          <div></div>
                      }


                      <Table
                        bordered
                      >
                        <thead className="text-default">
                          <tr>
                            <th>Substância</th>
                            <th className="text-center" style={{ width: "15%" }}>Excluir</th>
                          </tr>
                        </thead>
                        <tbody>
                          {listaSubstanciaProduto.map(substancia =>
                            <tr
                              key={substancia.id}
                            >
                              <td>{substancia.title}</td>
                              <td className="text-center">
                                <Button
                                  className="btn-icon btn-neutral"
                                  color="danger"
                                  id=""
                                  size="md"
                                  type="button"
                                  onClick={() => { removeSubstancia(substancia.id) }}
                                >
                                  <i className="fas fa-times" />
                                </Button>{" "}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>

                    </Col>

                  </Row>
                </Form>
              </TabPane>
            </TabContent>

            {/* ÚLTIMAS COMPRAS */}
            <TabContent activeTab={activeTab}>
              <TabPane tabId="5">
                {loadingLojas
                  ?
                  <Loading
                    tipo='componente'
                  >
                  </Loading>
                  :
                  <ReactSelect
                    name="Lojas"
                    label="Lojas"
                    placeholder="Selecione"
                    options={listaLojas}
                    defaultValue={listaLojas.length > 0 ? { id: listaLojas[0].id, title: listaLojas[0].title } : {}}
                    onChange={onChangeLojas}
                    className="mb-4"
                  >
                  </ReactSelect>
                }


                <Form>
                  <Row>
                    <Col md="10">

                      <ToolkitProvider
                        keyField="nota_fiscal"
                        data={ultCompras}
                        columns={colunas}
                      >
                        {
                          props => (
                            <div>
                              <BootstrapTable
                                striped
                                hover
                                //remote
                                keyField='nota_fiscal'
                                noDataIndication="Nenhum registro encontrado"
                                rowStyle={{ cursor: "pointer" }}
                                //remote={{ search: true, pagination: true }}
                                //onTableChange={ pesquisaProduto }
                                pagination={paginationFactory({
                                  sizePerPage: 15,
                                  hideSizePerPage: true,
                                  hidePageListOnlyOnePage: true,
                                  showTotal: false,
                                })}
                                {...props.baseProps}
                                data={ultCompras}
                                columns={colunas}
                                rowEvents={
                                  {
                                    onClick: (e, row, rowIndex) => {
                                      listarLotes(row);
                                    }
                                  }
                                }
                              />
                            </div>
                          )
                        }
                      </ToolkitProvider>

                    </Col>

                    <Col md="2" className='pl-0'>
                      <div className="card-2 mt-0">
                        <Table >
                          <thead className="text-default">
                            <tr>
                              <th>Nº Lote</th>
                              <th>Qtde</th>
                            </tr>
                          </thead>

                          <tbody>
                            {lotes.map((lote, index) =>
                              <tr key={lote.num_lote+index+lote.quantidade_compra} >
                                <td>{lote.num_lote}</td>
                                <td>{lote.quantidade_compra}</td>
                              </tr>
                            )}

                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </TabPane>
            </TabContent>

            {/* PRODUTOS RELACIONADOS */}
            <TabContent activeTab={activeTab}>
              <TabPane tabId="6">
                <Form>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label for="prod_prvenda">Produto</Label>
                        <AsyncSelect
                          loadOptions={pesquisaProdutoRelacionado}
                          onChange={selecionaProdutoRelacionado}
                          placeholder="Selecione"
                        >
                        </AsyncSelect>
                        {/* <Input
                          name="prod_prvenda"
                          id="prod_prvenda"
                          type="number"
                        //onBlur={this.onBlur.bind(this)}
                        //defaultValue={this.props.produtoEditar.prod_prvenda}
                        /> */}
                      </FormGroup>

                      <Button
                        className="float-right mt-0"
                        size="sm"
                        color="success"
                        onClick={gravarProdutoRelacionado}
                      >
                        Adicionar
                      </Button>
                    </Col>


                    <Col md="8">
                      {produtosRelacionados.length === 0
                        ?
                        <div className="card-2 selectSubstancia">Selecione os produtos...</div>
                        :
                        <div />
                      }
                      {
                        produtosRelacionados.map(produto =>
                          <Table bordered key={produto.produto_id}>
                            <thead className="text-default">
                              <tr>
                                <th>Código</th>
                                <th>Produto</th>
                                <th>Apresentação</th>
                                <th className="text-center" style={{ width: "15%" }}>Excluir</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <td>{produto.produto_id}</td>
                                <td>{produto.produto}</td>
                                <td>{produto.apresentacao}</td>
                                <td className="text-center">
                                  <Button
                                    className="btn-icon btn-neutral"
                                    color="danger"
                                    id=""
                                    size="md"
                                    type="button"
                                    onClick={() => { removeProdutoRelacionado(produto.produto_id) }}
                                  >
                                    <i className="fas fa-times" />
                                  </Button>{" "}
                                </td>
                              </tr>

                            </tbody>
                          </Table>
                        )}
                    </Col>
                  </Row>
                </Form>
              </TabPane>
            </TabContent>
            <Col
              className="text-center p-3"
            >
              <Button
                className={"mb-0 mt-0 " + disabledBtnGravar}
                color="success"
                size="md"
                onClick={gravaProduto}
              //disabled={disabledBtnGravar}
              >Salvar</Button>
              <Button
                className="mb-0 mt-0"
                color="default"
                size="md"
                onClick={() => { closeModal({ produto: { visible: false } }) }}
              >Fechar</Button>
            </Col>
          </ModalBody>
        </FormGroup>
      </>
    )
  }
}

/*class SelectBox extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div>
        <Select
          className="react-select"
          classNamePrefix="react-select"
          name="singleSelect"
          // value={this.state.optionsCategorias[this.findCat(this.props.defaultValue)]}
          // onChange={value => { this.select(value) }}
          // options={this.state.optionsCategorias}
          placeholder="Selecione"
        />
      </div>
    )
  }

}*/

export default FromCadastroProduto;